import { useState, useRef, useEffect } from "react";

// ══════════════════════════════════════════════════════════════════
//   HOW TO USE YOUR OWN LOGO IMAGE IN VS CODE
//   ↓↓↓  CHANGE THIS LINE  ↓↓↓
const LOGO_PATH = "/logo.png"; // Change to "./logo.png" when ready
//   ↑↑↑  CHANGE THIS LINE  ↑↑↑
// ══════════════════════════════════════════════════════════════════

const API_URL = "https://crm.boralogo.com/crm/api";

function getToken() {
  return localStorage.getItem("crm_token");
}

async function apiFetch(path, options = {}) {
  const res = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getToken()}`,
      ...(options.headers || {}),
    },
  });
  if (res.status === 401) {
    localStorage.removeItem("crm_token");
    localStorage.removeItem("crm_user");
    window.location.reload();
  }
  return res;
}

// ══════════════════════════════════════════════════════════════════
//   WHATSAPP + AI SETTINGS
//   Fill these in when your Hetzner server is ready
//   ↓↓↓  CHANGE THESE LINES  ↓↓↓
const EVOLUTION_URL      = null; // "https://crm.boralogo.com/evolution"
const EVOLUTION_KEY      = null; // "your-evolution-api-key"
const EVOLUTION_INSTANCE = null; // "bora-crm"
const CLAUDE_KEY         = null; // "sk-ant-your-claude-key"
//   ↑↑↑  CHANGE THESE LINES  ↑↑↑
// ══════════════════════════════════════════════════════════════════

const ORANGE      = "#E8890C";
const KC = { "New":"#3B82F6","Possible Fraud":"#EF4444","Docs Requested":"#F59E0B","Missing Docs":"#F97316","KYC Verified":"#10B981","Active Driver":"#8B5CF6","Test Account":"#000000" };
const KYC_OPTS    = ["New","Possible Fraud","Docs Requested","Missing Docs","KYC Verified","Active Driver", "Test"];
const TYPE_OPTS   = ["Rider","Driver"];
const PLAN_OPTS   = ["—","Moto","X","Comfort","Ultra Black"];
const GENDER_OPTS = ["Male","Female"];
const DOC_OPTS    = ["Approved","Reject","Blurry","Expired","Not valid"];
const TODAY = new Date().toLocaleDateString("en-CA", { timeZone: "America/Manaus" });
const MMDD  = TODAY.slice(5);
function fmtDate(d) {
  if (!d) return "—";
  const parts = d.split("-");
  if (parts.length !== 3) return d;
  return parts[2] + "/" + parts[1] + "/" + parts[0];
}
function gid() { return String(Math.floor(100000 + Math.random() * 900000)); }

const INIT_CLIENTS = [
  { id:gid(), name:"Ana",    surname:"Silva",    email:"ana@email.com",    phone:"+55 11 99999-0001", dob:"", gender:"Female", type:"Rider",  kycStatus:"New", annualPlan:"—", startDate:"", expiredDate:"", idExpired:"", cacExpired:"", selfieExpired:"", crlvExpired:"", lastActivity:"", createdDate:"01/01/2026", profilePic:"", notes:[], documents:[] },
  { id:gid(), name:"Carlos", surname:"Mendes",   email:"carlos@email.com", phone:"+55 11 98888-0002", dob:"", gender:"Male",   type:"Driver", kycStatus:"New", annualPlan:"—", startDate:"", expiredDate:"", idExpired:"", cacExpired:"", selfieExpired:"", crlvExpired:"", lastActivity:"", createdDate:"15/02/2026", profilePic:"", notes:[], documents:[] },
  { id:gid(), name:"Bruna",  surname:"Costa",    email:"bruna@email.com",  phone:"+55 21 97777-0003", dob:"", gender:"Female", type:"Rider",  kycStatus:"New", annualPlan:"—", startDate:"", expiredDate:"", idExpired:"", cacExpired:"", selfieExpired:"", crlvExpired:"", lastActivity:"", createdDate:"30/03/2026", profilePic:"", notes:[], documents:[] },
  { id:gid(), name:"Diego",  surname:"Ramos",    email:"diego@email.com",  phone:"+55 31 96666-0004", dob:"", gender:"Male",   type:"Driver", kycStatus:"New", annualPlan:"—", startDate:"", expiredDate:"", idExpired:"", cacExpired:"", selfieExpired:"", crlvExpired:"", lastActivity:"", createdDate:"05/04/2026", profilePic:"", notes:[], documents:[] },
  { id:gid(), name:"Elena",  surname:"Ferreira", email:"elena@email.com",  phone:"+55 51 95555-0005", dob:"", gender:"Female", type:"Rider",  kycStatus:"New", annualPlan:"—", startDate:"", expiredDate:"", idExpired:"", cacExpired:"", selfieExpired:"", crlvExpired:"", lastActivity:"", createdDate:"13/05/2026", profilePic:"", notes:[], documents:[] },
];

// ─── THEME ────────────────────────────────────────────────────────
function getT(dark) {
  return {
    bg:      dark ? "#0a0a0f"                 : "#f0f2f5",
    bg2:     dark ? "#111118"                 : "#ffffff",
    bg3:     dark ? "#1a1a25"                 : "#f8f9fa",
    bg4:     dark ? "rgba(255,255,255,0.04)"  : "rgba(0,0,0,0.035)",
    text:    dark ? "#f0f0f0"                 : "#111111",
    text2:   dark ? "#999999"                 : "#666666",
    border:  dark ? "rgba(255,255,255,0.09)"  : "rgba(0,0,0,0.10)",
    rowA:    dark ? "rgba(255,255,255,0.025)" : "#fafafa",
    rowB:    dark ? "rgba(255,255,255,0.01)"  : "#f3f3f3",
    inputBg: dark ? "rgba(255,255,255,0.06)"  : "#f8f9fa",
    inputBd: dark ? "rgba(255,255,255,0.13)"  : "#d8d8d8",
    cardBg:  dark ? "rgba(255,255,255,0.03)"  : "#ffffff",
    topBg:   dark ? "rgba(12,12,20,0.97)"     : "rgba(255,255,255,0.97)",
    sideBg:  dark ? "rgba(10,10,16,0.95)"     : "rgba(255,255,255,0.95)",
    modalBg: dark ? "#12121e"                 : "#ffffff",
  };
}

// ─── LOGO ─────────────────────────────────────────────────────────
function LogoSVG({ size = 120 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
      <circle cx="100" cy="100" r="98" fill="white" stroke={ORANGE} strokeWidth="4"/>
      <path d="M15 92 C28 48,65 28,100 50 C122 63,144 54,162 38 C175 26,190 31,194 42 L188 55 C182 45,170 43,155 55 C136 69,114 78,90 64 C62 47,36 58,20 108Z" fill="#1a1a1a"/>
      <polygon points="165,36 189,49 165,62" fill={ORANGE}/>
      <text x="18" y="118" fontFamily="Arial Black,Arial" fontWeight="900" fontSize="48" fill="#1a1a1a">Bora</text>
      <path d="M10 148 C32 122,60 120,84 133 C102 143,122 136,144 123 C164 112,182 121,191 133 L185 147 C175 135,158 128,136 140 C114 153,94 160,72 149 C48 137,26 139,12 165Z" fill={ORANGE}/>
      <text x="100" y="160" fontFamily="Arial Black,Arial" fontWeight="900" fontSize="36" fill={ORANGE}>Logo</text>
    </svg>
  );
}

function Logo({ size = 120 }) {
  if (LOGO_PATH) {
    return (
      <img src={LOGO_PATH} alt="Bora Logo"
        style={{ width:size, height:size, borderRadius:"50%", objectFit:"cover", border:`3px solid ${ORANGE}`, boxShadow:`0 0 30px rgba(232,137,12,0.35)` }}
        onError={e => { e.target.style.display = "none"; }}
      />
    );
  }
  return <LogoSVG size={size}/>;
}

function LogoSmall({ size = 36 }) {
  if (LOGO_PATH) {
    return (
      <img src={LOGO_PATH} alt="Bora Logo"
        style={{ width:size, height:size, borderRadius:"50%", objectFit:"cover", border:`2px solid ${ORANGE}`, flexShrink:0 }}
        onError={e => { e.target.style.display = "none"; }}
      />
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" style={{ borderRadius:"50%", flexShrink:0 }}>
      <circle cx="100" cy="100" r="98" fill="white" stroke={ORANGE} strokeWidth="4"/>
      <path d="M15 92 C28 48,65 28,100 50 C122 63,144 54,162 38 C175 26,190 31,194 42 L188 55 C182 45,170 43,155 55 C136 69,114 78,90 64 C62 47,36 58,20 108Z" fill="#1a1a1a"/>
      <polygon points="165,36 189,49 165,62" fill={ORANGE}/>
      <text x="18" y="118" fontFamily="Arial Black,Arial" fontWeight="900" fontSize="48" fill="#1a1a1a">Bora</text>
      <path d="M10 148 C32 122,60 120,84 133 C102 143,122 136,144 123 C164 112,182 121,191 133 L185 147 C175 135,158 128,136 140 C114 153,94 160,72 149 C48 137,26 139,12 165Z" fill={ORANGE}/>
      <text x="100" y="160" fontFamily="Arial Black,Arial" fontWeight="900" fontSize="36" fill={ORANGE}>Logo</text>
    </svg>
  );
}

// ─── SHARED COMPONENTS ────────────────────────────────────────────
function Inp({ value, onChange, type="text", placeholder, t, readOnly, style }) {
  if (type === "date") {
    const toDisplay = (v) => {
      if (!v) return "";
      const parts = v.split("-");
      if (parts.length !== 3) return v;
      return parts[2] + "/" + parts[1] + "/" + parts[0];
    };
    const toISO = (v) => {
      if (!v) return "";
      const parts = v.split("/");
      if (parts.length !== 3) return v;
      return parts[2] + "-" + parts[1] + "-" + parts[0];
    };
    return (
      <input
        type="text"
        value={toDisplay(value || "")}
        readOnly={readOnly}
        placeholder="DD/MM/AAAA"
        onChange={e => {
          if (onChange) onChange(toISO(e.target.value));
        }}
        style={{ width:"100%", background:t.inputBg, color:t.text, border:`1.5px solid ${t.inputBd}`, borderRadius:10, padding:"9px 13px", fontSize:13, outline:"none", opacity:readOnly?0.55:1, boxSizing:"border-box", ...style }}
        onFocus={e => { if(!readOnly) e.target.style.borderColor = ORANGE; }}
        onBlur={e  => { e.target.style.borderColor = t.inputBd; }}
      />
    );
  }
  return (
    <input type={type} value={value||""} readOnly={readOnly}
      placeholder={placeholder}
      onChange={e => onChange && onChange(e.target.value)}
      style={{ width:"100%", background:t.inputBg, color:t.text, border:`1.5px solid ${t.inputBd}`, borderRadius:10, padding:"9px 13px", fontSize:13, outline:"none", opacity:readOnly?0.55:1, boxSizing:"border-box", ...style }}
      onFocus={e => { if(!readOnly) e.target.style.borderColor = ORANGE; }}
      onBlur={e  => { e.target.style.borderColor = t.inputBd; }}
    />
  );
}

function Sel({ value, options, onChange, t, style }) {
  return (
    <select value={value||""} onChange={e => onChange(e.target.value)}
      style={{ width:"100%", background:t.inputBg, color:t.text, border:`1.5px solid ${t.inputBd}`, borderRadius:10, padding:"9px 13px", fontSize:13, outline:"none", cursor:"pointer", boxSizing:"border-box", ...style }}>
      {options.map(o => <option key={o} value={o}>{o}</option>)}
    </select>
  );
}

function Btn({ children, onClick, style }) {
  return (
    <button onClick={onClick}
      style={{ background:`linear-gradient(135deg,${ORANGE},#f5a623)`, color:"#fff", border:"none", borderRadius:11, padding:"10px 22px", fontSize:13, fontWeight:700, cursor:"pointer", boxShadow:`0 4px 14px rgba(232,137,12,0.38)`, transition:"all 0.18s", letterSpacing:0.3, ...style }}
      onMouseEnter={e => e.currentTarget.style.opacity = "0.87"}
      onMouseLeave={e => e.currentTarget.style.opacity = "1"}
    >{children}</button>
  );
}

function Badge({ status }) {
  return (
    <span style={{ background:KC[status]||"#888", color:"#fff", borderRadius:20, padding:"5px 14px", fontSize:12, fontWeight:700, boxShadow:"0 2px 8px rgba(0,0,0,0.22)", whiteSpace:"nowrap" }}>{status}</span>
  );
}

function Toast({ msg, show }) {
  return (
    <div style={{ position:"fixed", bottom:24, right:24, zIndex:9999, background:"linear-gradient(135deg,#10b981,#059669)", color:"#fff", padding:"12px 22px", borderRadius:12, fontWeight:700, fontSize:13, boxShadow:"0 6px 20px rgba(16,185,129,0.45)", opacity:show?1:0, transform:show?"translateY(0)":"translateY(10px)", transition:"all 0.3s", pointerEvents:"none" }}>{msg}</div>
  );
}

function Modal({ title, onClose, children, t }) {
  return (
    <div onClick={e => e.target === e.currentTarget && onClose()}
      style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.82)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:900, backdropFilter:"blur(4px)" }}>
      <div style={{ background:t.modalBg, border:`1px solid ${t.border}`, borderRadius:20, padding:32, width:430, maxWidth:"92vw", boxShadow:"0 20px 60px rgba(0,0,0,0.5)" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:22 }}>
          <span style={{ fontSize:21, fontWeight:800, color:t.text }}>{title}</span>
          <button onClick={onClose} style={{ background:"rgba(255,255,255,0.08)", border:"none", width:32, height:32, borderRadius:8, cursor:"pointer", color:t.text2, fontSize:16 }}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

function FG({ label, children }) {
  return (
    <div style={{ marginBottom:14 }}>
      <label style={{ display:"block", fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:"#888", marginBottom:6 }}>{label}</label>
      {children}
    </div>
  );
}

// ─── EXPORT CSV ───────────────────────────────────────────────────
function exportCSV(clients, filename) {
  const headers = ["ID","Name","Surname","Email","Phone","DOB","Gender","Type","KYC Status","Annual Plan","Start Date","Expired Date","ID Expired","CAC Expired","Selfie Expired","CRLV Expired","Created Date","Last Activity"];
  const keys    = ["id","name","surname","email","phone","dob","gender","type","kycStatus","annualPlan","startDate","expiredDate","idExpired","cacExpired","selfieExpired","crlvExpired","createdDate","lastActivity"];
  const rows = clients.map(c => keys.map(k => `"${(c[k]||"").toString().replace(/"/g,'""')}"`).join(","));
  const csv  = [headers.join(","), ...rows].join("\n");
  const blob = new Blob([csv], { type:"text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href = url; a.download = filename||"clients.csv"; a.click();
  URL.revokeObjectURL(url);
}

// ─── TABLE ────────────────────────────────────────────────────────
const T_COLS = ["ID","Name","Surname","Phone","Email","DOB","Type","KYC Status","Plan","ID Exp","CAC Exp","Selfie","Created","Last Activity"];
const T_KEYS = ["id","name","surname","phone","email","dob","type","kycStatus","annualPlan","idExpired","cacExpired","selfieExpired","createdDate","lastActivity"];

function ClientTable({ clients, onSelect, t, title }) {
  if (!clients.length) return (
    <div style={{ padding:50, textAlign:"center", color:t.text2, fontStyle:"italic" }}>No clients found.</div>
  );
  return (
    <div>
      <div style={{ display:"flex", justifyContent:"flex-end", marginBottom:10 }}>
        <Btn onClick={() => exportCSV(clients, `${title||"clients"}.csv`)} style={{ padding:"8px 18px", fontSize:12 }}>
          📊 Export to Excel
        </Btn>
      </div>
      <div style={{ overflowX:"auto", borderRadius:14, border:`1px solid ${t.border}` }}>
        <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
          <thead>
            <tr style={{ background:`linear-gradient(135deg,${ORANGE},#f5a623)` }}>
              {T_COLS.map(c => (
                <th key={c} style={{ padding:"12px 14px", textAlign:"left", color:"#fff", fontWeight:700, whiteSpace:"nowrap", borderRight:"1px solid rgba(255,255,255,0.15)", fontSize:11, textTransform:"uppercase", letterSpacing:0.5 }}>{c}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {clients.map((cl,i) => (
              <tr key={cl.id} onClick={() => onSelect(cl)}
                style={{ background:i%2===0?t.rowA:t.rowB, cursor:"pointer", transition:"background 0.12s" }}
                onMouseEnter={e => e.currentTarget.style.background = "rgba(232,137,12,0.12)"}
                onMouseLeave={e => e.currentTarget.style.background = i%2===0?t.rowA:t.rowB}
              >
                {T_KEYS.map(k => (
                  <td key={k} style={{ padding:"11px 14px", borderBottom:`1px solid ${t.border}`, whiteSpace:"nowrap", color:k==="kycStatus"?KC[cl[k]]:t.text, fontWeight:k==="kycStatus"?700:400 }}>
                    {k==="type"
                      ? <span style={{ padding:"3px 10px", borderRadius:20, fontSize:11, fontWeight:700, background:cl.type==="Driver"?"rgba(139,92,246,0.15)":"rgba(16,185,129,0.15)", color:cl.type==="Driver"?"#8b5cf6":"#10b981" }}>{cl[k]}</span>
                      : fmtDate(cl[k])}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ─── SEARCH PAGE ──────────────────────────────────────────────────
function SearchPage({ clients, onSelect, t }) {
  const [f, setF]       = useState({});
  const [results, setResults] = useState(null);
  const u = (k, v) => setF(p => ({ ...p, [k]:v }));

  function search() {
    let r = [...clients];
    if (f.id)    r = r.filter(c => c.id.includes(f.id));
    if (f.name)  r = r.filter(c => c.name.toLowerCase().includes(f.name.toLowerCase()));
    if (f.sur)   r = r.filter(c => c.surname.toLowerCase().includes(f.sur.toLowerCase()));
    if (f.phone) r = r.filter(c => c.phone.includes(f.phone));
    if (f.email) r = r.filter(c => c.email.toLowerCase().includes(f.email.toLowerCase()));
    if (f.type)  r = r.filter(c => c.type === f.type);
    if (f.kyc)   r = r.filter(c => c.kycStatus === f.kyc);
    if (f.gender)r = r.filter(c => c.gender === f.gender);
    if (f.dob)   r = r.filter(c => c.dob === f.dob);
    if (f.cf)    r = r.filter(c => c.createdDate >= f.cf);
    if (f.ct)    r = r.filter(c => c.createdDate <= f.ct);
    setResults(r);
  }

  const sg = (label, key, type="text") => (
    <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
      <label style={{ fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2 }}>{label}</label>
      <Inp value={f[key]||""} onChange={v => u(key,v)} type={type} t={t}/>
    </div>
  );
  const ss = (label, key, opts) => (
    <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
      <label style={{ fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2 }}>{label}</label>
      <select value={f[key]||""} onChange={e => u(key, e.target.value)}
        style={{ background:t.inputBg, color:t.text, border:`1.5px solid ${t.inputBd}`, borderRadius:10, padding:"9px 13px", fontSize:13, outline:"none" }}>
        <option value="">All</option>
        {opts.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );

  return (
    <div style={{ padding:26 }}>
      <div style={{ fontSize:22, fontWeight:800, color:t.text, marginBottom:22 }}>🔍 Search Clients</div>
      <div style={{ background:t.cardBg, border:`1px solid ${t.border}`, borderRadius:16, padding:22, marginBottom:20 }}>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(190px,1fr))", gap:14 }}>
          {sg("ID","id")} {sg("Name","name")} {sg("Surname","sur")}
          {sg("Phone","phone")} {sg("Email","email")} {sg("Date of Birth","dob","date")}
          {ss("Gender","gender",GENDER_OPTS)} {ss("Type","type",TYPE_OPTS)}
          {ss("KYC Status","kyc",KYC_OPTS)} {ss("Annual Plan","plan",PLAN_OPTS)}
          {sg("ID Expired","idExp","date")} {sg("CAC Expired","cacExp","date")}
          {sg("Selfie Expired","slfExp","date")} {sg("CRLV Expired","crlvExp","date")}
          {sg("Created From","cf","date")} {sg("Created To","ct","date")}
        </div>
        <Btn onClick={search} style={{ marginTop:20 }}>🔍 Search</Btn>
      </div>
      {results !== null && <ClientTable clients={results} onSelect={onSelect} t={t} title="search-results"/>}
    </div>
  );
}

// ─── PROFILE PICTURE ──────────────────────────────────────────────
function ProfilePic({ client, onChange, size=58 }) {
  const ref = useRef();
  return (
    <div style={{ position:"relative", width:size, height:size, flexShrink:0 }}>
      <div onClick={() => ref.current.click()}
        style={{ width:size, height:size, borderRadius:"50%", overflow:"hidden", border:`2.5px solid ${ORANGE}`, cursor:"pointer", background:"#1a1a25", display:"flex", alignItems:"center", justifyContent:"center", fontSize:size*0.32, fontWeight:800, color:ORANGE, boxShadow:`0 0 14px rgba(232,137,12,0.3)`, transition:"box-shadow 0.2s" }}
        onMouseEnter={e => e.currentTarget.style.boxShadow = `0 0 22px rgba(232,137,12,0.55)`}
        onMouseLeave={e => e.currentTarget.style.boxShadow = `0 0 14px rgba(232,137,12,0.3)`}
      >
        {client.profilePic
          ? <img src={client.profilePic} alt="profile" style={{ width:"100%", height:"100%", objectFit:"cover" }}/>
          : `${client.name[0]}${client.surname[0]}`}
      </div>
      <div onClick={() => ref.current.click()}
        style={{ position:"absolute", inset:0, borderRadius:"50%", background:"rgba(0,0,0,0.55)", display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontSize:10, fontWeight:700, cursor:"pointer", opacity:0, transition:"opacity 0.2s" }}
        onMouseEnter={e => e.currentTarget.style.opacity = "1"}
        onMouseLeave={e => e.currentTarget.style.opacity = "0"}
      >Edit</div>
      <input ref={ref} type="file" accept="image/*" style={{ display:"none" }}
        onChange={e => {
          const f = e.target.files[0]; if (!f) return;
          const r = new FileReader();
          r.onload = ev => onChange(ev.target.result);
          r.readAsDataURL(f);
        }}/>
    </div>
  );
}

// ─── NOTES TAB ────────────────────────────────────────────────────
function NotesTab({ client, onUpdate, t, user }) {
  const [selId, setSelId]     = useState(null);
  const [creating, setCreating] = useState(false);
  const [subj, setSubj]       = useState("");
  const [body, setBody]       = useState("");
  const notes = (client.notes || []).slice().sort((a,b) => {
  const dateA = new Date(b.createdAt || b.date || 0);
  const dateB = new Date(a.createdAt || a.date || 0);
  return dateA - dateB;
});
  const sel   = notes.find(n => n.id === selId);

  async function save() {
    if (!subj.trim() || !body.trim()) return;
    try {
      await apiFetch("/notes", {
        method: "POST",
        body: JSON.stringify({ clientId: client.id, subject: subj.trim(), body: body.trim() }),
      });
      const n = {
        id: Date.now(),
        author: user,
        subject: subj.trim(),
        body: body.trim(),
        date: new Date().toLocaleDateString("pt-BR", { timeZone:"America/Manaus" }),
        createdAt: new Date().toISOString(),
      };
      const updatedNotes = [n, ...(client.notes || [])];
      onUpdate({ ...client, notes: updatedNotes });
      setSelId(n.id); setCreating(false); setSubj(""); setBody("");
    } catch(e) {
      console.error("Error saving note:", e);
    }
  }

  return (
    <div style={{ display:"flex", height:"100%", overflow:"hidden" }}>
      <div style={{ width:270, borderRight:`1px solid ${t.border}`, display:"flex", flexDirection:"column", flexShrink:0 }}>
        <div style={{ padding:"12px 14px", borderBottom:`1px solid ${t.border}` }}>
          <Btn onClick={() => { setCreating(true); setSelId(null); }} style={{ width:"100%", padding:9 }}>+ Create Note</Btn>
        </div>
        <div style={{ overflowY:"auto", flex:1 }}>
          {!notes.length && <div style={{ padding:20, textAlign:"center", color:t.text2, fontSize:13 }}>No notes yet</div>}
          {notes.map((n,i)=>(
        <div key={n.id} onClick={()=>{setSelId(n.id);setCreating(false);}}
          style={{ padding:"14px 16px", borderBottom:`1px solid ${t.border}`, cursor:"pointer", background:selId===n.id?"rgba(232,137,12,0.12)":i%2===0?t.rowA:t.rowB, transition:"background 0.12s" }}
          onMouseEnter={e=>e.currentTarget.style.background="rgba(232,137,12,0.1)"}
          onMouseLeave={e=>e.currentTarget.style.background=selId===n.id?"rgba(232,137,12,0.12)":i%2===0?t.rowA:t.rowB}
        >
          <div style={{ fontSize:12, fontWeight:700, color:ORANGE, marginBottom:3 }}>{n.author}</div>
          <div style={{ fontSize:13, fontWeight:600, color:t.text, marginBottom:3 }}>{n.subject}</div>
          <div style={{ fontSize:11, color:t.text2 }}>
            {n.createdAt
              ? new Date(n.createdAt).toLocaleDateString("pt-BR", { timeZone:"America/Manaus" })
              : n.date || "—"}
          </div>
        </div>
      ))}
        </div>
      </div>
      <div style={{ flex:1, padding:22, overflowY:"auto" }}>
        {creating ? (
          <div>
            <div style={{ fontSize:18, fontWeight:800, color:t.text, marginBottom:16 }}>New Note</div>
            <FG label="Subject"><Inp value={subj} onChange={setSubj} placeholder="Note subject" t={t}/></FG>
            <FG label="Note">
              <textarea value={body} onChange={e => setBody(e.target.value)} placeholder="Write your note here..."
                style={{ width:"100%", minHeight:160, background:t.inputBg, color:t.text, border:`1.5px solid ${t.inputBd}`, borderRadius:12, padding:12, fontSize:13, resize:"vertical", outline:"none", boxSizing:"border-box", lineHeight:1.6 }}/>
            </FG>
            <Btn onClick={save}>Save Note</Btn>
          </div>
        ) : sel ? (
  <div>
    <div style={{ display:"flex", gap:10, marginBottom:14, flexWrap:"wrap", alignItems:"center" }}>
      <span style={{ fontSize:12, padding:"3px 12px", borderRadius:20, background:"rgba(232,137,12,0.15)", color:ORANGE, fontWeight:700 }}>{sel.author}</span>
      <span style={{ fontSize:12, padding:"3px 12px", borderRadius:20, background:t.bg4, color:t.text2 }}>
        {sel.createdAt
          ? new Date(sel.createdAt).toLocaleDateString("pt-BR", { timeZone:"America/Manaus" })
          : sel.date || "—"}
      </span>
    </div>
    <div style={{ fontSize:18, fontWeight:800, color:t.text, marginBottom:12 }}>{sel.subject}</div>
    <div style={{ background:t.bg4, borderRadius:12, padding:18, fontSize:14, lineHeight:1.7, whiteSpace:"pre-wrap", color:t.text, border:`1px solid ${t.border}` }}>{sel.body}</div>
  </div>
        ) : (
          <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", height:200, color:t.text2, gap:8 }}>
            <span style={{ fontSize:32 }}>📝</span><span>Select a note or create a new one</span>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── DOCS TAB ─────────────────────────────────────────────────────
function DocsTab({ client, onUpdate, t }) {
  const [selId, setSelId]     = useState(null);
  const [pending, setPending] = useState({});
  const fileRef = useRef();
  const docs = client.documents || [];
  const sel  = docs.find(d => d.id === selId);
  const cur  = sel ? { status:(pending[sel.id]?.status ?? sel.status), comment:(pending[sel.id]?.comment ?? sel.comment) } : {};

  async function upload(e) {
    const files = Array.from(e.target.files);
    for (const f of files) {
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const base64 = ev.target.result;
        const newDoc = {
          id: Date.now() + Math.random(),
          name: f.name,
          url: base64,
          isImg: f.type.startsWith("image"),
          isPdf: f.type === "application/pdf",
          status: "Approved",
          comment: "",
        };
        try {
          await apiFetch("/documents", {
            method: "POST",
            body: JSON.stringify({
              clientId: client.id,
              name: newDoc.name,
              url: newDoc.url,
              isImg: newDoc.isImg,
              isPdf: newDoc.isPdf,
              status: newDoc.status,
              comment: newDoc.comment,
            }),
          });
          onUpdate({ ...client, documents: [...(client.documents || []), newDoc] });
          setSelId(newDoc.id);
        } catch(err) {
          console.error("Error uploading doc:", err);
        }
      };
      reader.readAsDataURL(f);
    }
    e.target.value = "";
  }

  async function saveDoc() {
    if (!sel) return;
    const p = pending[sel.id] || {};
    try {
      if (sel.dbId) {
        await apiFetch(`/documents/${sel.dbId}`, {
          method: "PUT",
          body: JSON.stringify({ status: p.status || sel.status, comment: p.comment || sel.comment }),
        });
      }
      onUpdate({ ...client, documents:docs.map(d => d.id===sel.id ? { ...d, ...p } : d) });
      setPending(prev => { const n={...prev}; delete n[sel.id]; return n; });
    } catch(e) {
      console.error("Error saving doc:", e);
    }
  }

  function setPend(key, val) {
    setPending(prev => ({ ...prev, [sel.id]:{ ...(prev[sel.id]||{}), [key]:val } }));
  }

  return (
    <div style={{ display:"flex", height:"100%", overflow:"hidden" }}>
      <div style={{ width:270, borderRight:`1px solid ${t.border}`, display:"flex", flexDirection:"column", flexShrink:0 }}>
        <div style={{ padding:"12px 14px", borderBottom:`1px solid ${t.border}` }}>
          <Btn onClick={() => fileRef.current.click()} style={{ width:"100%", padding:9 }}>⬆ Upload Document</Btn>
          <input ref={fileRef} type="file" multiple accept="image/*,application/pdf" style={{ display:"none" }} onChange={upload}/>
        </div>
        <div style={{ overflowY:"auto", flex:1 }}>
          {!docs.length && <div style={{ padding:20, textAlign:"center", color:t.text2, fontSize:13 }}>No documents yet</div>}
          {docs.map((d,i) => (
            <div key={d.id} onClick={() => setSelId(d.id)}
              style={{ padding:"10px 14px", borderBottom:`1px solid ${t.border}`, cursor:"pointer", background:selId===d.id?"rgba(232,137,12,0.12)":i%2===0?t.rowA:t.rowB, transition:"background 0.12s" }}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(232,137,12,0.1)"}
              onMouseLeave={e => e.currentTarget.style.background = selId===d.id?"rgba(232,137,12,0.12)":i%2===0?t.rowA:t.rowB}
            >
              <div style={{ fontSize:12, fontWeight:600, color:t.text, wordBreak:"break-all" }}>{d.name}</div>
              <div style={{ fontSize:11, color:KC[d.status]||t.text2, marginTop:2, fontWeight:600 }}>{d.status}</div>
            </div>
          ))}
        </div>
      </div>
      <div style={{ flex:1, padding:20, display:"flex", flexDirection:"column", overflow:"auto" }}>
        {sel ? (
          <>
            <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", background:t.bg4, borderRadius:14, marginBottom:16, minHeight:220, border:`1px solid ${t.border}`, overflow:"hidden" }}>
              {sel.isImg
                ? <img src={sel.url} alt={sel.name} style={{ maxWidth:"100%", maxHeight:300, objectFit:"contain", borderRadius:10, display:"block" }} onError={e => { e.target.style.display="none"; }}/>
                : sel.isPdf
                  ? <div style={{ textAlign:"center", padding:30 }}><div style={{ fontSize:52, marginBottom:12 }}>📄</div><div style={{ fontSize:13, color:t.text2, marginBottom:12 }}>{sel.name}</div><a href={sel.url} target="_blank" rel="noreferrer" style={{ color:ORANGE, fontSize:13, fontWeight:700, textDecoration:"none" }}>Open PDF ↗</a></div>
                  : <div style={{ textAlign:"center", padding:30 }}><div style={{ fontSize:52, marginBottom:12 }}>📎</div><div style={{ fontSize:13, color:t.text2 }}>{sel.name}</div></div>
              }
            </div>
            <div style={{ display:"flex", gap:14, flexWrap:"wrap", alignItems:"flex-end", marginBottom:14 }}>
              <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
                <label style={{ fontSize:11, fontWeight:700, textTransform:"uppercase", color:t.text2 }}>Status</label>
                <Sel value={cur.status} options={DOC_OPTS} onChange={v => setPend("status",v)} t={t} style={{ width:170 }}/>
              </div>
              <div style={{ flex:1, minWidth:200, display:"flex", flexDirection:"column", gap:5 }}>
                <label style={{ fontSize:11, fontWeight:700, textTransform:"uppercase", color:t.text2 }}>Comments</label>
                <Inp value={cur.comment} onChange={v => setPend("comment",v)} placeholder="Write a comment..." t={t}/>
              </div>
            </div>
            <Btn onClick={saveDoc} style={{ alignSelf:"flex-start", padding:"10px 26px" }}>💾 Save Document</Btn>
          </>
        ) : (
          <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", flex:1, color:t.text2, gap:8 }}>
            <span style={{ fontSize:36 }}>📁</span><span>Select a document to preview</span>
          </div>
        )}
      </div>
    </div>
  );
}

// ─── CLIENT PAGE ──────────────────────────────────────────────────
function ClientPage({ client, onBack, onUpdate, t, user, showToast }) {
  const [tab, setTab] = useState("info");
  const [c, setC]     = useState({ ...client });

  async function save() {
    try {
      const res = await apiFetch(`/clients/${c.id}`, {
        method: "PUT",
        body: JSON.stringify(c),
      });
      if (res.ok) {
        onUpdate(c);
        showToast("Client saved successfully!");
      } else {
        showToast("Error saving client!");
      }
    } catch(e) {
      console.error("Error saving:", e);
      showToast("Error saving client!");
    }
  }

  const isRider = c.type === "Rider";

  function field(label, key, type="text", readOnly=false) {
    return (
      <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
        <label style={{ fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2 }}>{label}</label>
        <Inp value={c[key]||""} onChange={v => !readOnly && setC(p => ({ ...p, [key]:v }))} type={type} t={t} readOnly={readOnly}/>
      </div>
    );
  }

  function selField(label, key, opts) {
    return (
      <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
        <label style={{ fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2 }}>{label}</label>
        <Sel value={c[key]} options={opts} onChange={v => setC(p => ({ ...p, [key]:v }))} t={t}/>
      </div>
    );
  }

  const tabs = [
  { id:"info",   label:"📋 Info" },
  { id:"docs",   label:"📁 Docs" },
  { id:"review", label:"📋 Doc Review" },
  { id:"notes",  label:"📝 Notes" },
];

  return (
    <div style={{ display:"flex", flexDirection:"column", height:"100%" }}>
      <div style={{ padding:"14px 22px", display:"flex", alignItems:"center", gap:14, borderBottom:`1px solid ${t.border}`, background:t.topBg, flexShrink:0 }}>
        <Btn onClick={onBack} style={{ padding:"7px 16px", fontSize:13, background:"transparent", color:ORANGE, border:`1.5px solid ${ORANGE}`, boxShadow:"none" }}>← Back</Btn>
        <ProfilePic client={c} onChange={async url => {
  const updated = { ...c, profilePic:url };
  setC(updated);
  try {
    await apiFetch(`/clients/${c.id}`, {
      method: "PUT",
      body: JSON.stringify(updated),
    });
    onUpdate(updated);
    showToast("Profile picture updated!");
  } catch(e) {
    showToast("Error saving picture!");
  }
}}/>
        <div>
          <div style={{ fontSize:19, fontWeight:800, color:t.text }}>{c.name} {c.surname}</div>
          <div style={{ fontSize:12, color:t.text2, marginTop:2 }}>ID: <span style={{ userSelect:"all", cursor:"pointer" }} onClick={() => { navigator.clipboard.writeText(c.id); showToast("ID copied!"); }}>{c.id}</span> &nbsp;·&nbsp; {c.type}</div>
        </div>
        <Badge status={c.kycStatus}/>
      </div>

      <div style={{ display:"flex", borderBottom:`1px solid ${t.border}`, background:t.topBg, padding:"0 22px", gap:4, flexShrink:0 }}>
        {tabs.map(tb => (
          <button key={tb.id} onClick={() => setTab(tb.id)}
            style={{ background:"none", border:"none", borderBottom:`2px solid ${tab===tb.id?ORANGE:"transparent"}`, padding:"12px 18px", fontSize:13, cursor:"pointer", fontWeight:tab===tb.id?700:400, color:tab===tb.id?ORANGE:t.text2, transition:"all 0.15s" }}
          >{tb.label}</button>
        ))}
      </div>

      {tab==="info" && (
        <div style={{ flex:1, display:"flex", flexDirection:"column", overflow:"hidden" }}>
          <div style={{ flex:1, overflowY:"auto", padding:24 }}>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))", gap:16 }}>
              {field("First Name","name")}
              {field("Surname","surname")}
              {field("Email","email","email")}
              {field("Phone","phone")}
              {field("Date of Birth","dob","date")}
              {selField("Gender","gender",GENDER_OPTS)}
              {selField("Type","type",TYPE_OPTS)}
              {selField("KYC Status","kycStatus",KYC_OPTS)}
              {field("ID Expired Date","idExpired","date")}
              {field("CAC Expired Date","cacExpired","date")}
              {field("Selfie Expired Date","selfieExpired","date")}
              {!isRider && selField("Annual Plan","annualPlan",PLAN_OPTS)}
              {!isRider && field("Start Date","startDate","date")}
              {!isRider && field("Expired Date","expiredDate","date")}
              {!isRider && field("CRLV Expired Date","crlvExpired","date")}
              {field("Last Activity","lastActivity","text",true)}
              {field("Created Date","createdDate","text",true)}
            </div>
          </div>
          <div style={{ padding:"14px 24px", borderTop:`1px solid ${t.border}`, background:t.topBg, flexShrink:0 }}>
            <Btn onClick={save} style={{ padding:"11px 28px" }}>💾 Save Changes</Btn>
          </div>
        </div>
      )}
      {tab==="docs" && (
        <div style={{ flex:1, overflow:"hidden" }}>
          <DocsTab client={c} onUpdate={updated => { setC(updated); onUpdate(updated); }} t={t}/>
        </div>
      )}
      {tab==="notes" && (
        <div style={{ flex:1, overflow:"hidden" }}>
          <NotesTab client={c} onUpdate={updated => { setC(updated); onUpdate(updated); }} t={t} user={user}/>
        </div>
      )}
      {tab==="review" && (
        <div style={{ flex:1, overflow:"auto" }}>
          <DocReviewTab client={c} t={t}/>
        </div>
      )}
    </div>
  );
}

// ─── SETTINGS PAGE ────────────────────────────────────────────────
function SettingsPage({ t, dark, setDark }) {
  const [saved, setSaved] = useState(false);
  const [wa, setWa]       = useState(false);
  const [gm, setGm]       = useState(false);

  function save() { setSaved(true); setTimeout(() => setSaved(false), 2000); }

  const Sect = ({ title, children }) => (
    <div style={{ background:t.cardBg, border:`1px solid ${t.border}`, borderRadius:16, padding:22, marginBottom:18 }}>
      <div style={{ fontSize:15, fontWeight:800, color:t.text, marginBottom:16 }}>{title}</div>
      {children}
    </div>
  );

  const SI = ({ label, type="text", placeholder, val }) => (
    <div style={{ marginBottom:13 }}>
      <label style={{ display:"block", fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2, marginBottom:5 }}>{label}</label>
      <Inp value={val||""} onChange={() => {}} type={type} placeholder={placeholder} t={t}/>
    </div>
  );

  return (
    <div style={{ padding:26, maxWidth:720, overflowY:"auto" }}>
      <div style={{ fontSize:22, fontWeight:800, color:t.text, marginBottom:22 }}>⚙️ Settings</div>

      <Sect title="🎨 Appearance">
        <div style={{ display:"flex", alignItems:"center", gap:14 }}>
          <span style={{ fontSize:13, color:t.text }}>Theme:</span>
          <Btn onClick={() => setDark(!dark)} style={{ minWidth:140 }}>
            {dark ? "🌙 Dark Mode" : "☀️ Light Mode"}
          </Btn>
        </div>
      </Sect>

      <Sect title="🤖 AI / Claude API">
        <SI label="Claude API Key" type="password" placeholder="sk-ant-..."/>
        <p style={{ fontSize:12, color:t.text2, marginTop:-6 }}>Used for AI auto-replies via WhatsApp</p>
      </Sect>

      <Sect title="💬 WhatsApp — Evolution API">
        <p style={{ fontSize:13, color:t.text2, marginBottom:14 }}>Connect your existing WhatsApp number using Evolution API on your Hetzner server.</p>
        <SI label="Evolution API URL" placeholder="https://crm.boralogo.com/evolution"/>
        <SI label="Evolution API Key" type="password" placeholder="your-api-key"/>
        <SI label="Instance Name" placeholder="bora-crm"/>
        <Btn onClick={() => setWa(!wa)} style={{ background:wa?"linear-gradient(135deg,#10b981,#059669)":"linear-gradient(135deg,#E8890C,#f5a623)", boxShadow:wa?"0 4px 14px rgba(16,185,129,0.4)":"0 4px 14px rgba(232,137,12,0.38)" }}>
          {wa ? "✅ Connected" : "Connect WhatsApp"}
        </Btn>
      </Sect>

      <Sect title="📧 Gmail Automation">
        <p style={{ fontSize:13, color:t.text2, marginBottom:14 }}>Send automated Welcome emails to new clients.</p>
        <SI label="SMTP Host" val="smtp.gmail.com"/>
        <SI label="App Password / OAuth Token" type="password" placeholder="xxxx xxxx xxxx xxxx"/>
        <Btn onClick={() => setGm(!gm)} style={{ background:gm?"linear-gradient(135deg,#10b981,#059669)":"linear-gradient(135deg,#E8890C,#f5a623)", boxShadow:gm?"0 4px 14px rgba(16,185,129,0.4)":"0 4px 14px rgba(232,137,12,0.38)" }}>
          {gm ? "✅ Gmail Connected" : "Connect Gmail"}
        </Btn>
      </Sect>

      <Sect title="🔗 API Integration">
        <p style={{ fontSize:13, color:t.text2, marginBottom:12 }}>Register clients from Rider/Driver apps automatically:</p>
        <div style={{ background:"rgba(232,137,12,0.06)", border:"1px solid rgba(232,137,12,0.2)", borderRadius:12, padding:16, fontFamily:"monospace", fontSize:12, color:ORANGE, lineHeight:1.8 }}>
          POST /api/clients/register<br/><br/>
          {"{"}<br/>
          &nbsp;&nbsp;"name": "string",<br/>
          &nbsp;&nbsp;"email": "string",<br/>
          &nbsp;&nbsp;"phone": "string",<br/>
          &nbsp;&nbsp;"type": "Rider | Driver",<br/>
          &nbsp;&nbsp;"kycStatus": "New"<br/>
          {"}"}
        </div>
      </Sect>

      <Btn onClick={save} style={{ padding:"12px 34px", fontSize:14, background:saved?"linear-gradient(135deg,#10b981,#059669)":"linear-gradient(135deg,#E8890C,#f5a623)", boxShadow:saved?"0 4px 14px rgba(16,185,129,0.4)":"0 4px 14px rgba(232,137,12,0.38)" }}>
        {saved ? "✅ Saved!" : "💾 Save Settings"}
      </Btn>
    </div>
  );
}

// ─── WHATSAPP PAGE ────────────────────────────────────────────────
function WAPage({ t, clients }) {
  const [conversations, setConversations] = useState([]);
  const [selPhone, setSelPhone]           = useState(null);
  const [messages, setMessages]           = useState([]);
  const [newMsg, setNewMsg]               = useState("");
  const [sending, setSending]             = useState(false);
  const [loading, setLoading]             = useState(true);
  const [aiActive, setAiActive]           = useState(true);
  const messagesEndRef                    = useRef(null);

  // Request notification permission on load
  useEffect(() => {
    if (Notification.permission === "default") {
      Notification.requestPermission();
    }
  }, []);

  function notify(title, body) {
    if (Notification.permission === "granted") {
      new Notification(title, { body, icon: "/logo.png" });
    }
    // Play sound
    try {
      const a = new Audio("https://www.soundjay.com/buttons/sounds/button-09a.mp3");
      a.volume = 0.5;
      a.play().catch(() => {});
    } catch(e) {}
  }

  useEffect(() => {
    loadConversations();
    const interval = setInterval(loadConversations, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!selPhone) return;
    loadMessages(selPhone);
    loadAIStatus(selPhone);
    const interval = setInterval(() => loadMessages(selPhone), 3000);
    return () => clearInterval(interval);
  }, [selPhone]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  async function loadConversations() {
    try {
      const res  = await apiFetch("/whatsapp/conversations");
      const data = await res.json();
      if (Array.isArray(data)) {
        if (data.length > conversations.length && conversations.length > 0) {
          notify("Bora Logo CRM 💬", "Nova conversa no WhatsApp!");
        }
        setConversations(data);
      }
    } catch(e) {
      console.error("Error loading conversations:", e);
    }
    setLoading(false);
  }

  async function loadMessages(phone) {
    try {
      const res  = await apiFetch(`/whatsapp/messages/${phone}`);
      const data = await res.json();
      if (Array.isArray(data)) {
        const prevCount    = messages.length;
        const newIncoming  = data.filter(m => m.direction === 'incoming').length;
        const prevIncoming = messages.filter(m => m.direction === 'incoming').length;
        if (newIncoming > prevIncoming && prevCount > 0) {
          notify("Nova mensagem WhatsApp 💬", "Cliente enviou uma mensagem!");
        }
        setMessages(data);
      }
    } catch(e) {
      console.error("Error loading messages:", e);
    }
  }

  async function toggleAI() {
    const newStatus = aiActive ? 0 : 1;
    try {
      await apiFetch(`/whatsapp/settings/${selPhone}`, {
        method: "POST",
        body: JSON.stringify({ ai_active: newStatus }),
      });
      setAiActive(newStatus === 1);
    } catch(e) {
      console.error("Error toggling AI:", e);
    }
  }

  async function loadAIStatus(phone) {
    try {
      const res  = await apiFetch(`/whatsapp/settings/${phone}`);
      const data = await res.json();
      setAiActive(data.ai_active === 1);
    } catch(e) {
      console.error("Error loading AI status:", e);
    }
  }

  async function sendMessage() {
    if (!newMsg.trim() || !selPhone || sending) return;
    setSending(true);
    try {
      const res = await apiFetch("/whatsapp/send", {
        method: "POST",
        body: JSON.stringify({ phone: selPhone, message: newMsg.trim() }),
      });
      if (res.ok) {
        setMessages(prev => [...prev, {
          id: Date.now(),
          phone: selPhone,
          direction: "outgoing",
          message: newMsg.trim(),
          createdAt: new Date().toISOString(),
        }]);
        setNewMsg("");
        loadConversations();
      }
    } catch(e) {
      console.error("Error sending:", e);
    }
    setSending(false);
  }

  const active = conversations.find(c => c.phone === selPhone);

  return (
    <div style={{ display:"flex", height:"100%", overflow:"hidden" }}>

      {/* Conversations list */}
      <div style={{ width:320, borderRight:`1px solid ${t.border}`, display:"flex", flexDirection:"column", flexShrink:0 }}>
        <div style={{ padding:"16px 18px", borderBottom:`1px solid ${t.border}`, fontSize:15, fontWeight:800, color:t.text }}>
          💬 WhatsApp
        </div>

        {loading ? (
          <div style={{ padding:20, color:t.text2, fontSize:13 }}>Loading...</div>
        ) : conversations.length === 0 ? (
          <div style={{ padding:20, color:t.text2, fontSize:13 }}>
            No conversations yet.<br/>Messages will appear here when clients contact you.
          </div>
        ) : (
          <div style={{ overflowY:"auto", flex:1 }}>
            {conversations.map(conv => (
              <div key={conv.phone} onClick={() => setSelPhone(conv.phone)}
                style={{ padding:"12px 16px", borderBottom:`1px solid ${t.border}`, cursor:"pointer",
                  background: selPhone === conv.phone ? "rgba(232,137,12,0.1)" : "transparent",
                  borderLeft: selPhone === conv.phone ? `3px solid ${ORANGE}` : "3px solid transparent" }}
                onMouseEnter={e => { if (selPhone !== conv.phone) e.currentTarget.style.background = "rgba(232,137,12,0.05)"; }}
                onMouseLeave={e => { if (selPhone !== conv.phone) e.currentTarget.style.background = "transparent"; }}
              >
                <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                  <div style={{ width:40, height:40, borderRadius:"50%", background:ORANGE, display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontWeight:700, fontSize:14, flexShrink:0 }}>
                    {conv.name ? conv.name[0].toUpperCase() : "?"}
                  </div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:13, fontWeight:700, color:t.text }}>
                      {conv.name ? `${conv.name} ${conv.surname || ""}` : conv.phone}
                    </div>
                    <div style={{ fontSize:11, color:t.text2, whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>
                      {conv.lastText}
                    </div>
                  </div>
                  <div style={{ fontSize:10, color:t.text2, flexShrink:0 }}>
                    {new Date(conv.lastMessage).toLocaleTimeString("pt-BR", { hour:"2-digit", minute:"2-digit" })}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Chat area */}
      {selPhone ? (
        <div style={{ flex:1, display:"flex", flexDirection:"column", overflow:"hidden" }}>

          {/* Chat header */}
          <div style={{ padding:"12px 20px", borderBottom:`1px solid ${t.border}`, display:"flex", alignItems:"center", gap:12, background:t.topBg }}>
            <div style={{ width:38, height:38, borderRadius:"50%", background:ORANGE, display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontWeight:700 }}>
              {active?.name ? active.name[0].toUpperCase() : "?"}
            </div>
            <div>
              <div style={{ fontSize:14, fontWeight:700, color:t.text }}>
                {active?.name ? `${active.name} ${active.surname || ""}` : selPhone}
              </div>
              <div style={{ fontSize:11, color:t.text2 }}>{selPhone}</div>
            </div>
            <div style={{ marginLeft:"auto", display:"flex", alignItems:"center", gap:10 }}>
              <button onClick={toggleAI}
                style={{ background: aiActive ? "rgba(16,185,129,0.15)" : "rgba(239,68,68,0.15)", border: `1px solid ${aiActive ? "#10b981" : "#ef4444"}`, color: aiActive ? "#10b981" : "#ef4444", borderRadius:20, padding:"6px 14px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
                {aiActive ? "🤖 AI Active" : "👤 Manual Mode"}
              </button>
              <button onClick={() => { setSelPhone(null); setMessages([]); }}
                style={{ background:"none", border:"none", color:t.text2, cursor:"pointer", fontSize:18 }}>✕</button>
            </div>
          </div>

          {/* Messages */}
          <div style={{ flex:1, overflowY:"auto", padding:"16px 20px", display:"flex", flexDirection:"column", gap:10 }}>
            {messages.map(msg => (
              <div key={msg.id} style={{ display:"flex", justifyContent: msg.direction === "outgoing" ? "flex-end" : "flex-start" }}>
                <div style={{
                  maxWidth:"70%", padding:"10px 14px", borderRadius: msg.direction === "outgoing" ? "16px 16px 4px 16px" : "16px 16px 16px 4px",
                  background: msg.direction === "outgoing" ? ORANGE : t.cardBg,
                  color: msg.direction === "outgoing" ? "#fff" : t.text,
                  fontSize:13, lineHeight:1.5,
                  border: msg.direction === "incoming" ? `1px solid ${t.border}` : "none",
                }}>
                  {msg.direction === "incoming" && (
                    <div style={{ fontSize:10, color:ORANGE, fontWeight:700, marginBottom:4 }}>🤖 Claude AI</div>
                  )}
                  {msg.message}
                  <div style={{ fontSize:10, opacity:0.7, marginTop:4, textAlign:"right" }}>
                    {new Date(msg.createdAt).toLocaleTimeString("pt-BR", { hour:"2-digit", minute:"2-digit" })}
                  </div>
                </div>
              </div>
            ))}
            <div ref={messagesEndRef}/>
          </div>

          {/* Input */}
          <div style={{ padding:"12px 16px", borderTop:`1px solid ${t.border}`, display:"flex", gap:10, background:t.topBg }}>
            <input
              value={newMsg}
              onChange={e => setNewMsg(e.target.value)}
              onKeyDown={e => e.key === "Enter" && sendMessage()}
              placeholder="Type a message..."
              style={{ flex:1, background:t.inputBg, color:t.text, border:`1px solid ${t.inputBd}`, borderRadius:20, padding:"10px 16px", fontSize:13, outline:"none" }}
            />
            <button onClick={sendMessage} disabled={sending || !newMsg.trim()}
              style={{ background:ORANGE, color:"#fff", border:"none", borderRadius:20, padding:"10px 20px", fontSize:13, fontWeight:700, cursor:"pointer", opacity: sending || !newMsg.trim() ? 0.5 : 1 }}>
              {sending ? "..." : "Send"}
            </button>
          </div>
        </div>
      ) : (
        <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:12, color:t.text2 }}>
          <span style={{ fontSize:48 }}>💬</span>
          <span style={{ fontSize:16, fontWeight:600 }}>Select a conversation</span>
          <span style={{ fontSize:13 }}>Choose a chat from the left to start</span>
        </div>
      )}
    </div>
  );
}

// ─── TEMPLATES PAGE ───────────────────────────────────────────────
function TemplatesPage({ t, clients }) {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    async function loadTemplates() {
      try {
        const res  = await apiFetch("/templates");
        const data = await res.json();
        if (Array.isArray(data) && data.length > 0) {
          setTemplates(data);
        }
      } catch(e) {
        console.error("Error loading templates:", e);
      }
    }
    loadTemplates();
  }, []);

  const [selId, setSelId]       = useState(null);
  const [creating, setCreating] = useState(false);
  const [newName, setNewName]   = useState("");
  const [newSubj, setNewSubj]   = useState("");
  const [newBody, setNewBody]   = useState("");
  const [editMode, setEditMode] = useState(false);
  const [saved, setSaved]         = useState(false);
  const [preview, setPreview]     = useState(null);
  const [selClient, setSelClient] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [searchErr, setSearchErr] = useState(false);
  const sel = templates.find(tmp => tmp.id === selId);

function applyVars(body, client) {
  if (!client) return body;
  return body
    .replace(/{nome}/g, client.name)
    .replace(/{plano}/g, client.annualPlan || "—")
    .replace(/{data}/g, client.expiredDate ? client.expiredDate.split("-").reverse().join("/") : "—")
}

function openPreview(tmpl, clients) {
  setPreview(tmpl);
  setSelClient(clients[0] || null);
  setShowPreview(true);
}

  const selTmpl = templates.find(tmp => tmp.id === selId);

  function startNew() {
    setCreating(true);
    setSelId(null);
    setEditMode(false);
    setNewName("");
    setNewSubj("");
    setNewBody("");
  }

  async function saveTemplate() {
    if (!newName.trim() || !newBody.trim()) return;
    try {
      if (editMode && selId) {
        await apiFetch(`/templates/${selId}`, {
          method: "PUT",
          body: JSON.stringify({ name:newName, subject:newSubj, body:newBody }),
        });
        setTemplates(prev => prev.map(t => t.id===selId ? { ...t, name:newName, subject:newSubj, body:newBody } : t));
      } else {
        const res  = await apiFetch("/templates", {
          method: "POST",
          body: JSON.stringify({ name:newName, subject:newSubj, body:newBody }),
        });
        const data = await res.json();
        setTemplates(prev => [...prev, { id:data.id||Date.now(), name:newName, subject:newSubj, body:newBody }]);
      }
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
      setCreating(false);
      setEditMode(false);
    } catch(e) {
      console.error("Error saving template:", e);
    }
  }

  async function deleteTemplate(id) {
    try {
      await apiFetch(`/templates/${id}`, { method: "DELETE" });
      setTemplates(prev => prev.filter(t => t.id !== id));
      if (selId === id) { setSelId(null); setCreating(false); }
    } catch(e) {
      console.error("Error deleting template:", e);
    }
  }

  function startEdit(tmpl) {
    setSelId(tmpl.id);
    setNewName(tmpl.name);
    setNewSubj(tmpl.subject);
    setNewBody(tmpl.body);
    setEditMode(true);
    setCreating(true);
  }

  function copyTemplate(tmpl) {
    navigator.clipboard.writeText(tmpl.body);
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  }

  return (
    <div style={{ display:"flex", height:"100%", overflow:"hidden" }}>

      {/* LEFT — Template List */}
      <div style={{ width:260, borderRight:`1px solid ${t.border}`, display:"flex", flexDirection:"column", flexShrink:0, background:t.topBg }}>
        <div style={{ padding:"14px", borderBottom:`1px solid ${t.border}` }}>
          <Btn onClick={startNew} style={{ width:"100%", padding:10, fontSize:13 }}>+ Add Template</Btn>
        </div>
        <div style={{ overflowY:"auto", flex:1 }}>
          {templates.map((tmpl, i) => (
            <div key={tmpl.id}
              onClick={() => { setSelId(tmpl.id); setCreating(false); setEditMode(false); }}
              style={{ padding:"12px 14px", borderBottom:`1px solid ${t.border}`, cursor:"pointer", background:selId===tmpl.id&&!creating?"rgba(232,137,12,0.12)":i%2===0?t.rowA:t.rowB, transition:"background 0.12s" }}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(232,137,12,0.1)"}
              onMouseLeave={e => e.currentTarget.style.background = selId===tmpl.id&&!creating?"rgba(232,137,12,0.12)":i%2===0?t.rowA:t.rowB}
            >
              <div style={{ fontSize:13, fontWeight:600, color:t.text }}>{tmpl.name}</div>
              <div style={{ fontSize:11, color:t.text2, marginTop:3, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{tmpl.subject}</div>
            </div>
          ))}
        </div>
      </div>

      {/* RIGHT — Template View / Edit */}
      <div style={{ flex:1, display:"flex", flexDirection:"column", overflow:"hidden" }}>
        {creating ? (
          /* ── CREATE / EDIT FORM ── */
          <div style={{ flex:1, display:"flex", flexDirection:"column", overflow:"hidden" }}>
            <div style={{ padding:"14px 22px", borderBottom:`1px solid ${t.border}`, background:t.topBg, display:"flex", alignItems:"center", justifyContent:"space-between" }}>
              <span style={{ fontSize:16, fontWeight:800, color:t.text }}>{editMode?"Edit Template":"New Template"}</span>
              <button onClick={() => { setCreating(false); setEditMode(false); }}
                style={{ background:"none", border:`1px solid ${t.border}`, color:t.text2, borderRadius:8, padding:"5px 12px", fontSize:12, cursor:"pointer" }}>Cancel</button>
            </div>
            <div style={{ flex:1, overflowY:"auto", padding:24 }}>

              {/* Template Name */}
              <div style={{ marginBottom:18 }}>
                <label style={{ display:"block", fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2, marginBottom:6 }}>Template Name</label>
                <input value={newName} onChange={e => setNewName(e.target.value)} placeholder="ex: Welcome Rider, Docs Requested..."
                  style={{ width:"100%", background:t.inputBg, color:t.text, border:`1.5px solid ${t.inputBd}`, borderRadius:10, padding:"10px 13px", fontSize:14, outline:"none", boxSizing:"border-box" }}
                  onFocus={e => e.target.style.borderColor = ORANGE}
                  onBlur={e  => e.target.style.borderColor = t.inputBd}
                />
              </div>

              {/* Subject */}
              <div style={{ marginBottom:18 }}>
                <label style={{ display:"block", fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2, marginBottom:6 }}>Subject <span style={{ color:t.text2, fontSize:10, fontWeight:400, textTransform:"none" }}>(for emails)</span></label>
                <input value={newSubj} onChange={e => setNewSubj(e.target.value)} placeholder="ex: Bem-vindo à Bora Logo!"
                  style={{ width:"100%", background:t.inputBg, color:t.text, border:`1.5px solid ${t.inputBd}`, borderRadius:10, padding:"10px 13px", fontSize:14, outline:"none", boxSizing:"border-box" }}
                  onFocus={e => e.target.style.borderColor = ORANGE}
                  onBlur={e  => e.target.style.borderColor = t.inputBd}
                />
              </div>

              {/* Template Body */}
              <div style={{ marginBottom:18 }}>
                <label style={{ display:"block", fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2, marginBottom:6 }}>
                  Template
                  <span style={{ color:t.text2, fontSize:10, fontWeight:400, textTransform:"none", marginLeft:8 }}>
                    Use {"{nome}"} {"{id}"} {"{plano}"} {"{data}"} as variables
                  </span>
                </label>
                <textarea value={newBody} onChange={e => setNewBody(e.target.value)}
                  placeholder="Write your template here in Portuguese..."
                  style={{ width:"100%", minHeight:280, background:t.inputBg, color:t.text, border:`1.5px solid ${t.inputBd}`, borderRadius:12, padding:14, fontSize:14, resize:"vertical", outline:"none", boxSizing:"border-box", lineHeight:1.7 }}
                  onFocus={e => e.target.style.borderColor = ORANGE}
                  onBlur={e  => e.target.style.borderColor = t.inputBd}
                />
              </div>

              {/* Save Button */}
              <Btn onClick={saveTemplate} style={{ padding:"12px 36px", fontSize:14, background:saved?"linear-gradient(135deg,#10b981,#059669)":"linear-gradient(135deg,#E8890C,#f5a623)", boxShadow:saved?"0 4px 14px rgba (16,185,129,0.4)":"0 4px 14px rgba(232,137,12,0.38)" }}>
                {saved ? "✅ Saved!" : "💾 Save Template"}
              </Btn>
            </div>
          </div>
        ) : selTmpl ? (
          /* ── TEMPLATE VIEW ── */
          <div style={{ flex:1, display:"flex", flexDirection:"column", overflow:"hidden" }}>
            <div style={{ padding:"14px 22px", borderBottom:`1px solid ${t.border}`, background:t.topBg, display:"flex", alignItems:"center", gap:10 }}>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:18, fontWeight:800, color:t.text }}>{selTmpl.name}</div>
                {sel.subject && <div style={{ fontSize:12, color:t.text2, marginTop:2 }}>📧 {selTmpl.subject}</div>}
              </div>
              <button onClick={() => openPreview(selTmpl, clients)}
                style={{ background:`linear-gradient(135deg,${ORANGE},#f5a623)`, border:"none", color:"#fff", borderRadius:9, padding:"7px 16px", fontSize:12, fontWeight:700, cursor:"pointer", boxShadow:`0 3px 10px rgba(232,137,12,0.35)` }}>
                👁️ Preview & Send
              </button>
              <button onClick={() => copyTemplate(selTmpl)}
                style={{ background:"rgba(232,137,12,0.1)", border:`1px solid rgba(232,137,12,0.3)`, color:ORANGE, borderRadius:9, padding:"7px 16px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
                📋 Copy
              </button>
              <button onClick={() => startEdit(selTmpl)}
                style={{ background:"rgba(232,137,12,0.1)", border:`1px solid rgba(232,137,12,0.3)`, color:ORANGE, borderRadius:9, padding:"7px 16px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
                ✏️ Edit
              </button>
              <button onClick={() => deleteTemplate(selTmpl.id)}
                style={{ background:"rgba(239,68,68,0.1)", border:`1px solid rgba(239,68,68,0.3)`, color:"#ef4444", borderRadius:9, padding:"7px 16px", fontSize:12, fontWeight:700, cursor:"pointer" }}>
                🗑️ Delete
              </button>
            </div>
            <div style={{ flex:1, overflowY:"auto", padding:24 }}>
              {/* Variables hint */}
              <div style={{ background:"rgba(232,137,12,0.08)", border:`1px solid rgba(232,137,12,0.2)`, borderRadius:10, padding:"10px 14px", marginBottom:20, fontSize:12, color:ORANGE }}>
                💡 Variables: <strong>{"{nome}"}</strong> = client name &nbsp;·&nbsp; <strong>{"{id}"}</strong> = client ID &nbsp;·&nbsp; <strong>{"{plano}"}</strong> = plan &nbsp;·&nbsp; <strong>{"{data}"}</strong> = date
              </div>
              {/* Template body preview */}
              <div style={{ background:t.bg4, border:`1px solid ${t.border}`, borderRadius:14, padding:24, fontSize:14, lineHeight:1.8, whiteSpace:"pre-wrap", color:t.text }}>
                {selTmpl.body}
              </div>
            </div>
          </div>
        ) : (
          /* ── EMPTY STATE ── */
          <div style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", color:t.text2, gap:12 }}>
            <span style={{ fontSize:48 }}>📝</span>
            <span style={{ fontSize:16, fontWeight:600, color:t.text }}>Select a template</span>
            <span style={{ fontSize:13 }}>or click <strong style={{ color:ORANGE }}>+ Add Template</strong> to create a new one</span>
          </div>
        )}
      </div>

      {/* ── PREVIEW MODAL ── */}
      {showPreview && preview && (
        <div onClick={e => e.target===e.currentTarget && setShowPreview(false)}
          style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.82)", zIndex:999, display:"flex", alignItems:"center", justifyContent:"center", backdropFilter:"blur(4px)" }}>
          <div style={{ background:t.modalBg, border:`1px solid ${t.border}`, borderRadius:20, padding:0, width:580, maxWidth:"94vw", maxHeight:"88vh", display:"flex", flexDirection:"column", boxShadow:"0 20px 60px rgba(0,0,0,0.5)", overflow:"hidden" }}>

            {/* Modal Header */}
            <div style={{ padding:"18px 24px", borderBottom:`1px solid ${t.border}`, display:"flex", alignItems:"center", justifyContent:"space-between", flexShrink:0 }}>
              <div>
                <div style={{ fontSize:17, fontWeight:800, color:t.text }}>👁️ Preview & Send</div>
                <div style={{ fontSize:12, color:t.text2, marginTop:2 }}>Template: <strong style={{ color:ORANGE }}>{preview.name}</strong></div>
              </div>
              <button onClick={() => setShowPreview(false)}
                style={{ background:"rgba(255,255,255,0.08)", border:"none", width:32, height:32, borderRadius:8, cursor:"pointer", color:t.text2, fontSize:16 }}>✕</button>
            </div>

            {/* Client ID Search */}
<div style={{ padding:"16px 24px", borderBottom:`1px solid ${t.border}`, flexShrink:0, background:t.bg4 }}>
  <label style={{ fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2, display:"block", marginBottom:6 }}>Client ID</label>
  <div style={{ display:"flex", gap:10 }}>
    <input
      id="previewClientId"
      placeholder="Type the client ID..."
      style={{ flex:1, background:t.inputBg, color:t.text, border:`1.5px solid ${t.inputBd}`, borderRadius:10, padding:"9px 13px", fontSize:13, outline:"none" }}
      onFocus={e => e.target.style.borderColor = ORANGE}
      onBlur={e => e.target.style.borderColor = t.inputBd}
      onKeyDown={e => {
        if (e.key === "Enter") {
          const found = clients.find(c => c.id === e.target.value.trim());
          if (found) setSelClient(found);
          else { setSelClient(null); setSearchErr(true); setTimeout(()=>setSearchErr(false), 3000); }
        }
      }}
    />
    <button
      onClick={() => {
        const val = document.getElementById("previewClientId").value.trim();
        const found = clients.find(c => c.id === val);
        if (found) setSelClient(found);
        else { setSelClient(null); setSearchErr(true); setTimeout(()=>setSearchErr(false), 3000); }
      }}
      style={{ background:`linear-gradient(135deg,${ORANGE},#f5a623)`, color:"#fff", border:"none", borderRadius:10, padding:"9px 18px", fontSize:13, fontWeight:700, cursor:"pointer" }}>
      Search
    </button>
  </div>
  
  {searchErr && (
  <div style={{ marginTop:10, background:"rgba(239,68,68,0.1)", border:"1px solid rgba(239,68,68,0.3)", borderRadius:8, padding:"8px 12px", fontSize:13, color:"#ef4444" }}>
    ❌ Client ID not found. Please check and try again.
  </div>
)}

  {selClient && (
  <div style={{ marginTop:10, background:"rgba(16,185,129,0.1)", border:"1px solid rgba(16,185,129,0.3)", borderRadius:8, padding:"8px 12px", fontSize:13, color:"#10b981", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
    <span>✅ <strong>{selClient.name} {selClient.surname}</strong> &nbsp;·&nbsp; {selClient.type}</span>
    <button onClick={() => setSelClient(null)} style={{ background:"none", border:"none", color:"#10b981", cursor:"pointer", fontSize:16 }}>✕</button>
  </div>
)}
</div>

            {/* Preview Content */}
            <div style={{ flex:1, overflowY:"auto", padding:24 }}>
              {/* Subject preview */}
              {preview.subject && (
                <div style={{ marginBottom:16 }}>
                  <label style={{ fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2, display:"block", marginBottom:6 }}>📧 Email Subject</label>
                  <div style={{ background:t.bg4, border:`1px solid ${t.border}`, borderRadius:10, padding:"10px 14px", fontSize:14, color:t.text, fontWeight:600 }}>
                    {selClient ? applyVars(preview.subject, selClient) : preview.subject}
                  </div>
                </div>
              )}

              {/* Body preview */}
              <div style={{ marginBottom:20 }}>
                <label style={{ fontSize:11, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2, display:"block", marginBottom:6 }}>Message Preview</label>
                <div style={{ background:t.bg4, border:`1px solid ${t.border}`, borderRadius:12, padding:20, fontSize:14, lineHeight:1.8, whiteSpace:"pre-wrap", color:t.text, minHeight:180 }}>
                  {selClient ? applyVars(preview.body, selClient) : preview.body}
                </div>
              </div>

              {/* Variables used */}
              <div style={{ background:"rgba(232,137,12,0.08)", border:`1px solid rgba(232,137,12,0.2)`, borderRadius:10, padding:"10px 14px", fontSize:12, color:ORANGE, marginBottom:20 }}>
                💡 💡 <strong>{"{nome}"}</strong> · <strong>{"{plano}"}</strong> · <strong>{"{data}"}</strong>
              </div>
            </div>

            {/* Action Buttons */}
            <div style={{ padding:"16px 24px", borderTop:`1px solid ${t.border}`, display:"flex", gap:12, flexShrink:0, background:t.bg4 }}>
              <button
                onClick={() => {
                  const text = selClient ? applyVars(preview.body, selClient) : preview.body;
                  navigator.clipboard.writeText(text);
                  setSaved(true);
                  setTimeout(() => setSaved(false), 2000);
                }}
                style={{ flex:1, background:`linear-gradient(135deg,${ORANGE},#f5a623)`, color:"#fff", border:"none", borderRadius:11, padding:"12px", fontSize:14, fontWeight:700, cursor:"pointer", boxShadow:`0 4px 14px rgba(232,137,12,0.38)` }}>
                📋 Copy Message
              </button>
              <button
                onClick={() => {
                  if (!selClient) return;
                  const subject = applyVars(preview.subject || preview.name, selClient);
                  const body    = applyVars(preview.body, selClient);
                  window.open(`mailto:${selClient.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`);
                }}
                style={{ flex:1, background:`linear-gradient(135deg,#3B82F6,#2563eb)`, color:"#fff", border:"none", borderRadius:11, padding:"12px", fontSize:14, fontWeight:700, cursor:"pointer", boxShadow:`0 4px 14px rgba(59,130,246,0.38)` }}>
                📧 Open in Gmail
              </button>
              <button
                onClick={() => {
                  if (!selClient) return;
                  const body = applyVars(preview.body, selClient);
                  const phone = selClient.phone.replace(/\D/g,"");
                  window.open(`https://wa.me/${phone}?text=${encodeURIComponent(body)}`);
                }}
                style={{ flex:1, background:`linear-gradient(135deg,#10b981,#059669)`, color:"#fff", border:"none", borderRadius:11, padding:"12px", fontSize:14, fontWeight:700, cursor:"pointer", boxShadow:`0 4px 14px rgba(16,185,129,0.38)` }}>
                💬 Send WhatsApp
              </button>
            </div>

          </div>
        </div>
      )}

      {/* Toast */}
      {saved && (
        <div style={{ position:"fixed", bottom:24, right:24, background:"linear-gradient(135deg,#10b981,#059669)", color:"#fff", padding:"12px 22px", borderRadius:12, fontWeight:700, fontSize:13, boxShadow:"0 6px 20px rgba(16,185,129,0.45)", zIndex:9999 }}>
          ✅ {newName ? "Template saved!" : "Copied to clipboard!"}
        </div>
      )}
    </div>
  );
}

// ─── NEW CLIENT PAGE ──────────────────────────────────────────────
function NCField({ label, k, type="text", required, form, upd, errors, t }) {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
      <label style={{ fontSize:12, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2 }}>
        {label} {required && <span style={{ color:"#ef4444" }}>*</span>}
      </label>
      <input type={type} value={form[k]||""} onChange={e => upd(k, e.target.value)}
        placeholder={type==="date" ? "DD/MM/AAAA" : ""}
        style={{ background:t.inputBg, color:t.text, border:`1.5px solid ${errors[k]?"#ef4444":t.inputBd}`, borderRadius:10, padding:"10px 13px", fontSize:14, outline:"none", width:"100%", boxSizing:"border-box" }}
        onFocus={e => e.target.style.borderColor = errors[k]?"#ef4444":ORANGE}
        onBlur={e  => e.target.style.borderColor = errors[k]?"#ef4444":t.inputBd}
      />
      {errors[k] && <span style={{ fontSize:11, color:"#ef4444" }}>{errors[k]}</span>}
    </div>
  );
}

function NCSelField({ label, k, opts, required, form, upd, errors, t }) {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
      <label style={{ fontSize:12, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2 }}>
        {label} {required && <span style={{ color:"#ef4444" }}>*</span>}
      </label>
      <select value={form[k]||""} onChange={e => upd(k, e.target.value)}
        style={{ background:t.inputBg, color:t.text, border:`1.5px solid ${errors[k]?"#ef4444":t.inputBd}`, borderRadius:10, padding:"10px 13px", fontSize:14, outline:"none", width:"100%", boxSizing:"border-box" }}>
        <option value="">Select...</option>
        {opts.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
      {errors[k] && <span style={{ fontSize:11, color:"#ef4444" }}>{errors[k]}</span>}
    </div>
  );
}

function NewClientPage({ t, clients, setClients, setPage, showToast, fetchClients }) {
  const [form, setForm] = useState({
    name:"", surname:"", email:"", phone:"55", dob:"",
    gender:"Gender", type:"Rider", kycStatus:"New",
    annualPlan:"", startDate:"", expiredDate:"",
    idExpired:"", cacExpired:"", selfieExpired:"", crlvExpired:"",
  });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);

  const upd = (k, v) => {
    setForm(p => ({ ...p, [k]: v }));
    setErrors(p => ({ ...p, [k]: "" }));
  };

  function validate() {
    const e = {};
    if (!form.name.trim())    e.name    = "Name is required";
    if (!form.surname.trim()) e.surname = "Surname is required";
    if (!form.email.trim())   e.email   = "Email is required";
    if (!form.phone.trim())   e.phone   = "Phone is required";
    if (!form.type)           e.type    = "Type is required";
    if (form.email && clients.find(c => c.email.toLowerCase() === form.email.toLowerCase())) {
      e.email = "Email already registered";
    }
    setErrors(e);
    return Object.keys(e).length === 0;
  }

  async function submit() {
    if (!validate()) return;
    const newClient = {
      ...form,
      id:           gid(),
      kycStatus:    "New",
      createdDate:  new Date().toLocaleDateString("en-CA", { timeZone:"America/Manaus" }),
      lastActivity: new Date().toLocaleDateString("en-CA", { timeZone:"America/Manaus" }),
      profilePic:   "",
      notes:        [],
      documents:    [],
    };
    try {
      const res = await apiFetch("/clients", {
        method: "POST",
        body: JSON.stringify(newClient),
        headers: { "x-api-key": "" }
      });
      const data = await res.json();
      if (!res.ok) {
        if (data.error === "Email already registered") {
          setErrors(p => ({ ...p, email: "Email already registered" }));
          setSuccess(false);
          return;
        }
      }
      await fetchClients();
    } catch(e) {
      console.error("Error creating client:", e);
    }
    setSuccess(true);
    setTimeout(() => {
      setSuccess(false);
      setForm({ name:"", surname:"", email:"", phone:"55", dob:"", gender:"Female", type:"Rider", kycStatus:"New", annualPlan:"", startDate:"", expiredDate:"", idExpired:"", cacExpired:"", selfieExpired:"", crlvExpired:"" });
      setPage("all");
      showToast("Client registered successfully!");
    }, 2000);
  }

  const isRider = form.type === "Rider";

  return (
    <div style={{ padding:26, maxWidth:800 }}>

      {/* Header */}
      <div style={{ display:"flex", alignItems:"center", gap:14, marginBottom:28 }}>
        <div>
          <div style={{ fontSize:22, fontWeight:800, color:t.text }}>➕ New Client</div>
          <div style={{ fontSize:13, color:t.text2, marginTop:2 }}>Register a new Rider or Driver manually</div>
        </div>
      </div>

      {/* Success message */}
      {success && (
        <div style={{ background:"rgba(16,185,129,0.1)", border:"1px solid rgba(16,185,129,0.3)", borderRadius:12, padding:"16px 20px", marginBottom:20, fontSize:15, color:"#10b981", fontWeight:700, display:"flex", alignItems:"center", gap:10 }}>
          ✅ Client registered successfully! Redirecting...
        </div>
      )}

      {/* Form */}
      <div style={{ background:t.cardBg, border:`1px solid ${t.border}`, borderRadius:16, padding:28 }}>

        {/* Type selector */}
        <div style={{ marginBottom:24 }}>
          <label style={{ fontSize:12, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2, display:"block", marginBottom:10 }}>
            Type <span style={{ color:"#ef4444" }}>*</span>
          </label>
          <div style={{ display:"flex", gap:12 }}>
            {["Rider","Driver"].map(tp => (
              <button key={tp} onClick={() => upd("type", tp)}
                style={{ flex:1, padding:"14px", borderRadius:12, border:`2px solid ${form.type===tp?ORANGE:t.inputBd}`, background:form.type===tp?"rgba(232,137,12,0.1)":t.inputBg, color:form.type===tp?ORANGE:t.text2, fontSize:15, fontWeight:700, cursor:"pointer", transition:"all 0.2s" }}>
                {tp === "Rider" ? "🛵 Rider" : "🚗 Driver"}
              </button>
            ))}
          </div>
        </div>

        {/* Personal info */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))", gap:16, marginBottom:16 }}>
          <NCField label="First Name"    k="name"    required form={form} upd={upd} errors={errors} t={t}/>
          <NCField label="Surname"       k="surname" required form={form} upd={upd} errors={errors} t={t}/>
          <NCField label="Email"         k="email"   type="email" required form={form} upd={upd} errors={errors} t={t}/>
          <NCField label="Phone Number"  k="phone"   required form={form} upd={upd} errors={errors} t={t}/>
          <NCField label="Date of Birth" k="dob"     type="date" form={form} upd={upd} errors={errors} t={t}/>
          <NCSelField label="Gender" k="gender" opts={GENDER_OPTS} form={form} upd={upd} errors={errors} t={t}/>
        </div>

        {/* Divider */}
        <div style={{ borderTop:`1px solid ${t.border}`, margin:"20px 0" }}/>

        {/* KYC & Plan */}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))", gap:16, marginBottom:16 }}>
          <div style={{ display:"flex", flexDirection:"column", gap:5 }}>
            <label style={{ fontSize:12, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:t.text2 }}>KYC Status</label>
            <div style={{ background:"rgba(59,130,246,0.1)", border:"1px solid rgba(59,130,246,0.3)", borderRadius:10, padding:"10px 13px", fontSize:14, color:"#3B82F6", fontWeight:700 }}>🆕 New</div>
            <span style={{ fontSize:11, color:t.text2 }}>Always "New" on registration</span>
          </div>
          {!isRider && <NCSelField label="Annual Plan" k="annualPlan" opts={PLAN_OPTS} form={form} upd={upd} errors={errors} t={t}/>}
          {!isRider && <NCField label="Start Date"   k="startDate"   type="date" form={form} upd={upd} errors={errors} t={t}/>}
          {!isRider && <NCField label="Expired Date" k="expiredDate" type="date" form={form} upd={upd} errors={errors} t={t}/>}
        </div>

        {/* Divider */}
        <div style={{ borderTop:`1px solid ${t.border}`, margin:"20px 0" }}/>

        {/* Document expiry dates */}
        <div style={{ marginBottom:16 }}>
          <div style={{ fontSize:13, fontWeight:700, color:t.text, marginBottom:14 }}>📄 Document Expiry Dates <span style={{ color:t.text2, fontWeight:400, fontSize:12 }}>(optional)</span></div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(220px,1fr))", gap:16 }}>
            <NCField label="ID Expired Date"     k="idExpired"     type="date" form={form} upd={upd} errors={errors} t={t}/>
            <NCField label="CAC Expired Date"    k="cacExpired"    type="date" form={form} upd={upd} errors={errors} t={t}/>
            <NCField label="Selfie Expired Date" k="selfieExpired" type="date" form={form} upd={upd} errors={errors} t={t}/>
            {!isRider && <NCField label="CRLV Expired Date" k="crlvExpired" type="date" form={form} upd={upd} errors={errors} t={t}/>}
          </div>
        </div>

        {/* Divider */}
        <div style={{ borderTop:`1px solid ${t.border}`, margin:"20px 0" }}/>

        {/* Buttons */}
        <div style={{ display:"flex", gap:12, alignItems:"center" }}>
          <button onClick={() => setPage("all")}
            style={{ background:"none", border:`1.5px solid ${t.border}`, color:t.text2, borderRadius:11, padding:"12px 24px", fontSize:14, fontWeight:600, cursor:"pointer" }}>
            Cancel
          </button>
          <button onClick={submit}
            style={{ background:`linear-gradient(135deg,${ORANGE},#f5a623)`, color:"#fff", border:"none", borderRadius:11, padding:"12px 36px", fontSize:15, fontWeight:700, cursor:"pointer", boxShadow:`0 4px 16px rgba(232,137,12,0.38)`, flex:1 }}>
            ➕ Register Client
          </button>
        </div>
      </div>

      {/* Info box */}
      <div style={{ marginTop:16, background:"rgba(232,137,12,0.06)", border:`1px solid rgba(232,137,12,0.2)`, borderRadius:12, padding:"12px 16px", fontSize:12, color:t.text2 }}>
        💡 <strong style={{ color:ORANGE }}>Note:</strong> KYC Status is always set to <strong style={{ color:"#3B82F6" }}>New</strong> on registration.
        You can change it manually in the client profile after reviewing documents.
      </div>
    </div>
  );
}

// ─── DOC REVIEW TAB ───────────────────────────────────────────────
const DRIVER_DOCS = [
  { code:"POIFB",      name:"CNH (Proof of Identity Front and Back)" },
  { code:"SELFIE",     name:"Selfie (Profile Photo)" },
  { code:"CAC",        name:"CAC (Certidão de Antecedentes Criminais)" },
  { code:"CRLV",       name:"CRLV (Documento do Veículo)" },
  { code:"CONTRACT",   name:"Contract (Contrato de Adesão)" },
  { code:"TERMS",      name:"Terms (Termos de Uso)" },
  { code:"POP",        name:"POP (Proof of Payment)" },
  { code:"CAR PHOTOS", name:"Car Photos (Fotos do Veículo)" },
];

const RIDER_DOCS = [
  { code:"POIFB",  name:"POIFB (Proof of Identity Front and Back - RG)" },
  { code:"CAC",    name:"CAC (Certidão de Antecedentes Criminais)" },
  { code:"SELFIE", name:"Selfie (Profile Photo)" },
];

const DOC_STATUS_OPTS = ["Pending","Verified","Rejected","Blurry","Expired","Not Valid"];

const DOC_STATUS_COLORS = {
  "Pending":   "#888888",
  "Verified":  "#10b981",
  "Rejected":  "#ef4444",
  "Blurry":    "#f59e0b",
  "Expired":   "#f97316",
  "Not Valid": "#8b5cf6",
};

const DOC_STATUS_EMOJI = {
  "Pending":   "⏳",
  "Verified":  "✅",
  "Rejected":  "❌",
  "Blurry":    "🌫️",
  "Expired":   "📅",
  "Not Valid": "🚫",
};

function DocReviewTab({ client, t }) {
  const [docs, setDocs]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving]   = useState({});
  const [initialized, setInitialized] = useState(false);

  const docList = client.type === "Driver" ? DRIVER_DOCS : RIDER_DOCS;

  useEffect(() => {
    loadDocs();
  }, [client.id]);

  async function loadDocs() {
    setLoading(true);
    try {
      const res  = await apiFetch(`/doc-review/${client.id}`);
      const data = await res.json();
      if (Array.isArray(data) && data.length > 0) {
        setDocs(data);
        setInitialized(true);
      } else {
        setInitialized(false);
      }
    } catch(e) {
      console.error("Error loading doc review:", e);
    }
    setLoading(false);
  }

  async function initializeDocs() {
    try {
      for (const doc of docList) {
        await apiFetch("/doc-review", {
          method: "POST",
          body: JSON.stringify({ clientId: client.id, doc_code: doc.code, doc_name: doc.name, status: "Pending" }),
        });
      }
      await loadDocs();
    } catch(e) {
      console.error("Error initializing docs:", e);
    }
  }

  async function updateStatus(docId, status) {
    setSaving(prev => ({ ...prev, [docId]: true }));
    try {
      await apiFetch(`/doc-review/${docId}`, {
        method: "PUT",
        body: JSON.stringify({ status }),
      });
      setDocs(prev => prev.map(d => d.id === docId ? { ...d, status } : d));
    } catch(e) {
      console.error("Error updating doc status:", e);
    }
    setSaving(prev => ({ ...prev, [docId]: false }));
  }

  if (loading) return (
    <div style={{ display:"flex", alignItems:"center", justifyContent:"center", height:200, color:t.text2 }}>
      Loading...
    </div>
  );

  if (!initialized) return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", height:300, gap:16 }}>
      <span style={{ fontSize:40 }}>📋</span>
      <span style={{ fontSize:16, fontWeight:600, color:t.text }}>Doc Review not started yet</span>
      <span style={{ fontSize:13, color:t.text2 }}>Click below to create the checklist for this client</span>
      <Btn onClick={initializeDocs} style={{ padding:"12px 32px" }}>
        📋 Create Doc Review Checklist
      </Btn>
    </div>
  );

  return (
    <div style={{ padding:24, overflowY:"auto" }}>
      <div style={{ fontSize:16, fontWeight:800, color:t.text, marginBottom:20 }}>
        📋 Document Review — {client.type}
      </div>

      {/* Stats bar */}
      <div style={{ display:"flex", gap:12, marginBottom:24, flexWrap:"wrap" }}>
        {Object.entries(DOC_STATUS_COLORS).map(([status, color]) => {
          const count = docs.filter(d => d.status === status).length;
          if (count === 0) return null;
          return (
            <div key={status} style={{ background:`${color}20`, border:`1px solid ${color}40`, borderRadius:20, padding:"4px 12px", fontSize:12, fontWeight:700, color }}>
              {DOC_STATUS_EMOJI[status]} {status}: {count}
            </div>
          );
        })}
      </div>

      {/* Document list */}
      <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
        {docs.map(doc => (
          <div key={doc.id} style={{ display:"flex", alignItems:"center", gap:16, background:t.cardBg, border:`1px solid ${t.border}`, borderRadius:12, padding:"14px 18px", borderLeft:`4px solid ${DOC_STATUS_COLORS[doc.status]||"#888"}` }}>
            
            {/* Status emoji */}
            <span style={{ fontSize:22, flexShrink:0 }}>{DOC_STATUS_EMOJI[doc.status]||"⏳"}</span>

            {/* Doc name */}
            <div style={{ flex:1 }}>
              <div style={{ fontSize:13, fontWeight:700, color:t.text }}>{doc.doc_code}</div>
              <div style={{ fontSize:11, color:t.text2, marginTop:2 }}>{doc.doc_name}</div>
            </div>

            {/* Status dropdown */}
            <select
              value={doc.status}
              onChange={e => updateStatus(doc.id, e.target.value)}
              disabled={saving[doc.id]}
              style={{ background:t.inputBg, color:DOC_STATUS_COLORS[doc.status]||t.text, border:`1.5px solid ${DOC_STATUS_COLORS[doc.status]||t.inputBd}`, borderRadius:10, padding:"8px 12px", fontSize:13, fontWeight:700, outline:"none", cursor:"pointer", minWidth:130 }}
            >
              {DOC_STATUS_OPTS.map(s => (
                <option key={s} value={s}>{DOC_STATUS_EMOJI[s]} {s}</option>
              ))}
            </select>

            {/* Saving indicator */}
            {saving[doc.id] && <span style={{ fontSize:11, color:t.text2 }}>Saving...</span>}
          </div>
        ))}
      </div>

      {/* Summary */}
      <div style={{ marginTop:20, background:"rgba(232,137,12,0.06)", border:`1px solid rgba(232,137,12,0.2)`, borderRadius:12, padding:"12px 16px", fontSize:12, color:t.text2 }}>
        💡 Change status to <strong style={{ color:"#ef4444" }}>Rejected</strong>, <strong style={{ color:"#f59e0b" }}>Blurry</strong>, <strong style={{ color:"#f97316" }}>Expired</strong> or <strong style={{ color:"#8b5cf6" }}>Not Valid</strong> then change KYC Status to <strong style={{ color:ORANGE }}>Missing Docs</strong> and click Save — Claude AI will automatically notify the client about which documents need to be resent.
      </div>
    </div>
  );
}

// ─── NAV ──────────────────────────────────────────────────────────
const NAV = [
  { id:"search",  emoji:"🔍", label:"Search",         filter:null,                                      section:"MENU" },
  { id:"all",     emoji:"👥", label:"All Clients",    filter:null,                                      section:null },
  { id:"riders",  emoji:"🛵", label:"Riders",         filter:c => c.type==="Rider",                    section:null },
  { id:"drivers", emoji:"🚗", label:"Drivers",        filter:c => c.type==="Driver",                   section:null },
  { id:"new",     emoji:"🆕", label:"New",            filter:c => c.kycStatus==="New",                 section:"KYC STATUS" },
  { id:"pf",      emoji:"⚠️", label:"Possible Fraud", filter:c => c.kycStatus==="Possible Fraud",      section:null },
  { id:"dr",      emoji:"📄", label:"Docs Requested", filter:c => c.kycStatus==="Docs Requested",      section:null },
  { id:"md",      emoji:"📋", label:"Missing Docs",   filter:c => c.kycStatus==="Missing Docs",        section:null },
  { id:"kv",      emoji:"✅", label:"KYC Verified",   filter:c => c.kycStatus==="KYC Verified",        section:null },
  { id:"act",     emoji:"🟢", label:"Active Driver",  filter:c => c.kycStatus==="Active Driver",       section:null },
  { id:"bday",    emoji:"🎂", label:"Happy Birthday", filter:c => c.dob && c.dob.slice(5)===MMDD,      section:"ALERTS" },
  { id:"planx",   emoji:"📅", label:"Plan Expired",   filter:c => c.expiredDate===TODAY,               section:null },
  { id:"idx",     emoji:"🪪",  label:"ID Expired",     filter:c => c.idExpired===TODAY,                 section:null },
  { id:"crlvx",   emoji:"🚙", label:"CRLV Expired",   filter:c => c.crlvExpired===TODAY,               section:null },
  { id:"cacx",    emoji:"📑", label:"CAC Expired",    filter:c => c.cacExpired===TODAY,                section:null },
  { id:"slfx",    emoji:"🤳", label:"Selfie Expired", filter:c => c.selfieExpired===TODAY,             section:null },
  { id:"wa",      emoji:"💬", label:"WhatsApp",       filter:null,                                     section:"TOOLS" },
  { id:"newclient",emoji:"➕",label:"New Client",   filter:null,                                     section:null },
  { id:"temp",    emoji:"📝", label:"Templates",      filter:null,                                     section:null },
  
];

// ─── MAIN APP ─────────────────────────────────────────────────────
export default function App() {
  const [dark, setDark]               = useState(false);
  const t                             = getT(dark);
  const [screen, setScreen] = useState(() => {
  return localStorage.getItem("crm_token") ? "crm" : "landing";
});
  const [page, setPage]               = useState("search");
  const [showSettings, setShowSettings] = useState(false);
  const [selClient, setSelClient]     = useState(null);
  const [clients, setClients]         = useState([]);
  const [loadingClients, setLoadingClients] = useState(false);
  const [waUnread, setWaUnread]       = useState(0);
  const [sbOpen, setSbOpen]           = useState(true);
  const [showLogin, setShowLogin]     = useState(false);
  const [showSignup, setShowSignup]   = useState(false);
  const [me, setMe] = useState(() => {
  return localStorage.getItem("crm_user") || "admin";
});
  const [lUser, setLUser]             = useState("");
  const [lPass, setLPass]             = useState("");
  const [lErr, setLErr]               = useState("");
  const [sEmail, setSEmail]           = useState("");
  const [sUser, setSUser]             = useState("");
  const [sPass, setSPass]             = useState("");
  const [sConf, setSConf]             = useState("");
  const [sErr, setSErr]               = useState("");
  const [sOk, setSok]                 = useState(false);
  const [toast, setToast]             = useState({ show:false, msg:"" });
  useEffect(() => {
  if (localStorage.getItem("crm_token")) {
    fetchClients();
    fetchWAUnread();
    const interval = setInterval(fetchWAUnread, 10000);
    return () => clearInterval(interval);
  }
}, []);

  function showToast(msg) {
    setToast({ show:true, msg });
    setTimeout(() => setToast({ show:false, msg:"" }), 2500);
  }

  async function doLogin() {
  if (!lUser.trim() || !lPass.trim()) { setLErr("Please enter username and password."); return; }
  try {
    const res = await fetch("https://crm.boralogo.com/crm/api/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username: lUser.trim(), password: lPass.trim() })
    });
    const data = await res.json();
    if (!res.ok) { setLErr(data.error || "Invalid credentials"); return; }
    localStorage.setItem("crm_token", data.token);
    localStorage.setItem("crm_user", data.username);
    setMe(data.username);
    setShowLogin(false); setLErr(""); setLUser(""); setLPass("");
    setScreen("crm");
    fetchClients();
  } catch(e) {
    setLErr("Connection error. Please try again.");
  }
}

  async function fetchClients() {
  setLoadingClients(true);
  try {
    const res  = await apiFetch("/clients");
    const data = await res.json();
    if (Array.isArray(data)) setClients(data);
  } catch(e) {
    console.error("Error fetching clients:", e);
  }
  setLoadingClients(false);
}

  async function fetchWAUnread() {
  try {
    const res  = await apiFetch("/whatsapp/unread");
    const data = await res.json();
    setWaUnread(data.count || 0);
  } catch(e) {}
}

  function doSignup() {
    if (!sEmail||!sUser||!sPass||!sConf) { setSErr("Please fill all fields."); return; }
    if (sPass !== sConf) { setSErr("Passwords do not match."); return; }
    setMe(sUser); setSok(true);
    setTimeout(() => {
      setShowSignup(false); setSok(false); setSErr("");
      setSEmail(""); setSUser(""); setSPass(""); setSConf("");
      setScreen("crm");
    }, 2200);
  }

  async function updateClient(updated) {
  try {
    await apiFetch(`/clients/${updated.id}`, {
      method: "PUT",
      body: JSON.stringify(updated),
    });
    setClients(prev => prev.map(c => c.id===updated.id ? updated : c));
    setSelClient(updated);
  } catch(e) {
    console.error("Error updating client:", e);
  }
}

  const SBW = sbOpen ? 218 : 52;

  // ── LANDING ──
  if (screen === "landing") {
    return (
      <div style={{ minHeight:"100vh", background:dark?"linear-gradient(135deg,#0a0a0f,#12121a)":"linear-gradient(135deg,#f0f2f5,#e8eaf0)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", position:"relative", overflow:"hidden", fontFamily:"'Segoe UI',Arial,sans-serif" }}>
        <div style={{ position:"absolute", top:-160, right:-160, width:580, height:580, borderRadius:"50%", background:"radial-gradient(circle,rgba(232,137,12,.16),transparent 65%)", pointerEvents:"none" }}/>
        <div style={{ position:"absolute", bottom:-160, left:-160, width:520, height:520, borderRadius:"50%", background:"radial-gradient(circle,rgba(232,137,12,.10),transparent 65%)", pointerEvents:"none" }}/>

        <button onClick={() => setDark(!dark)}
          style={{ position:"absolute", top:20, right:20, background:dark?"rgba(255,255,255,0.08)":"rgba(0,0,0,0.08)", border:"none", borderRadius:10, padding:"8px 16px", fontSize:13, fontWeight:600, cursor:"pointer", color:dark?"#eee":"#111", zIndex:10 }}>
          {dark ? "☀️ Light" : "🌙 Dark"}
        </button>

        <div style={{ borderRadius:"50%", overflow:"hidden", boxShadow:`0 0 40px rgba(232,137,12,0.35)`, marginBottom:24, zIndex:2 }}>
          <Logo size={140}/>
        </div>

        <h1 style={{ fontSize:36, fontWeight:800, textAlign:"center", color:dark?"#fff":"#111", letterSpacing:-0.5, zIndex:2, marginBottom:8, fontFamily:"'Segoe UI',Arial,sans-serif" }}>Bora Logo Technologies</h1>
        <p style={{ fontSize:15, color:dark?"#888":"#666", marginBottom:40, fontStyle:"italic", zIndex:2 }}>Smart CRM for the ride of your life</p>

        <div style={{ display:"flex", gap:14, zIndex:2 }}>
          <Btn onClick={() => setShowLogin(true)} style={{ padding:"14px 44px", fontSize:16, borderRadius:12 }}>Login</Btn>
          <button onClick={() => setShowSignup(true)}
            style={{ background:"transparent", border:`2px solid rgba(232,137,12,0.6)`, borderRadius:12, padding:"14px 44px", fontSize:16, fontWeight:700, cursor:"pointer", color:dark?"#eee":"#111", transition:"all 0.2s" }}
            onMouseEnter={e => e.currentTarget.style.borderColor = ORANGE}
            onMouseLeave={e => e.currentTarget.style.borderColor = "rgba(232,137,12,0.6)"}
          >Sign Up</button>
        </div>

        {showLogin && (
          <Modal title="Welcome back" onClose={() => { setShowLogin(false); setLErr(""); }} t={t}>
            <FG label="Username"><Inp value={lUser} onChange={setLUser} placeholder="Enter your username" t={t}/></FG>
            <FG label="Password"><Inp value={lPass} onChange={setLPass} type="password" placeholder="Enter your password" t={t}/></FG>
            {lErr && <div style={{ color:"#ef4444", fontSize:12, marginBottom:10, padding:"8px 12px", background:"rgba(239,68,68,0.1)", borderRadius:8 }}>{lErr}</div>}
            <Btn onClick={doLogin} style={{ width:"100%", padding:13, fontSize:15 }}>Login</Btn>
          </Modal>
        )}

        {showSignup && (
          <Modal title="Create Account" onClose={() => { setShowSignup(false); setSErr(""); setSok(false); }} t={t}>
            {sOk ? (
              <div style={{ textAlign:"center", color:"#10b981", fontSize:16, fontWeight:700, padding:"22px 0" }}>
                ✅ Account created!<br/>
                <small style={{ fontSize:13, fontWeight:400, color:t.text2 }}>Welcome email sent. Redirecting...</small>
              </div>
            ) : (
              <>
                <FG label="Email"><Inp value={sEmail} onChange={setSEmail} type="email" placeholder="your@email.com" t={t}/></FG>
                <FG label="Username"><Inp value={sUser} onChange={setSUser} placeholder="Choose a username" t={t}/></FG>
                <FG label="Password"><Inp value={sPass} onChange={setSPass} type="password" placeholder="Create password" t={t}/></FG>
                <FG label="Confirm Password"><Inp value={sConf} onChange={setSConf} type="password" placeholder="Repeat password" t={t}/></FG>
                {sErr && <div style={{ color:"#ef4444", fontSize:12, marginBottom:10, padding:"8px 12px", background:"rgba(239,68,68,0.1)", borderRadius:8 }}>{sErr}</div>}
                <Btn onClick={doSignup} style={{ width:"100%", padding:13, fontSize:15 }}>Create Account</Btn>
              </>
            )}
          </Modal>
        )}
      </div>
    );
  }

  // ── CRM ──
  return (
    <div style={{ display:"flex", flexDirection:"column", height:"100vh", background:t.bg, fontFamily:"'Segoe UI',Arial,sans-serif", overflow:"hidden" }}>
      <style>{`
  * { box-sizing:border-box; }
  ::-webkit-scrollbar { width:4px; height:4px; }
  ::-webkit-scrollbar-thumb { background:${ORANGE}; border-radius:4px; }
  ::-webkit-scrollbar-track { background:transparent; }
  select option { background:#1a1a25 !important; color:#ffffff !important; }
  body.light select option { background:#ffffff !important; color:#111111 !important; }`}
      </style>

      {/* TOPBAR */}
      <div style={{ height:58, background:t.topBg, borderBottom:`1px solid ${t.border}`, display:"flex", alignItems:"center", padding:"0 18px", gap:12, flexShrink:0 }}>
        <div style={{ borderRadius:"50%", overflow:"hidden", flexShrink:0 }}><LogoSmall size={36}/></div>
        <span style={{ fontSize:15, fontWeight:800, background:`linear-gradient(135deg,${ORANGE},#f5a623)`, WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent" }}>Bora Logo Technologies</span>
        <div style={{ flex:1 }}/>
        <button onClick={() => { setShowSettings(!showSettings); setSelClient(null); }}
          style={{ background:showSettings?"rgba(232,137,12,0.15)":"none", border:"none", fontSize:18, cursor:"pointer", padding:"6px 8px", borderRadius:9, color:showSettings?ORANGE:t.text2, transition:"all 0.2s" }}>⚙️</button>
        <button onClick={() => setDark(!dark)}
          style={{ background:"none", border:`1.5px solid ${t.border}`, color:t.text, borderRadius:9, padding:"5px 12px", fontSize:12, fontWeight:600, cursor:"pointer" }}
          onMouseEnter={e => e.currentTarget.style.borderColor = ORANGE}
          onMouseLeave={e => e.currentTarget.style.borderColor = t.border}
        >{dark ? "☀️" : "🌙"}</button>
        <div style={{ background:"rgba(232,137,12,0.12)", color:ORANGE, border:"1px solid rgba(232,137,12,0.25)", borderRadius:20, padding:"5px 14px", fontSize:12, fontWeight:700 }}>👤 {me}</div>
        <button onClick={() => { 
                localStorage.removeItem("crm_token"); 
                localStorage.removeItem("crm_user");
                setScreen("landing"); 
                setSelClient(null); 
                setShowSettings(false); 
                setClients([]);
              }}
          style={{ background:"none", border:`1.5px solid ${t.border}`, color:t.text2, borderRadius:9, padding:"5px 12px", fontSize:12, fontWeight:600, cursor:"pointer" }}>↪ Logout</button>
      </div>

      <div style={{ display:"flex", flex:1, overflow:"hidden" }}>
        {/* SIDEBAR */}
        <div style={{ width:SBW, background:t.sideBg, borderRight:`1px solid ${t.border}`, display:"flex", flexDirection:"column", flexShrink:0, transition:"width 0.22s ease", overflow:"hidden" }}>
          <button onClick={() => setSbOpen(!sbOpen)}
            style={{ width:"100%", background:"none", border:"none", borderBottom:`1px solid ${t.border}`, padding:12, fontSize:13, cursor:"pointer", color:t.text2, textAlign:sbOpen?"right":"center", transition:"color 0.2s" }}
            onMouseEnter={e => e.currentTarget.style.color = ORANGE}
            onMouseLeave={e => e.currentTarget.style.color = t.text2}
          >{sbOpen ? "◀" : "▶"}</button>
          <div style={{ overflowY:"auto", flex:1, padding:"6px 0" }}>
            {NAV.map((item, idx) => {
              const count    = item.filter ? clients.filter(item.filter).length : null;
              const isActive = page===item.id && !showSettings && !selClient;
              const prev     = NAV[idx-1];
              return (
                <div key={item.id}>
                  {item.section && item.section !== prev?.section && sbOpen && (
                    <div style={{ padding:"10px 14px 4px", fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:1.5, color:t.text2, opacity:0.5 }}>{item.section}</div>
                  )}
                  <button onClick={() => { setPage(item.id); setSelClient(null); setShowSettings(false); }} title={item.label}
                    style={{ display:"flex", alignItems:"center", gap:9, width:"100%", background:isActive?"linear-gradient(135deg,rgba(232,137,12,0.2),rgba(232,137,12,0.07))":"none", border:"none", borderLeft:`3px solid ${isActive?ORANGE:"transparent"}`, padding:sbOpen?"10px 14px":"10px 0", justifyContent:sbOpen?"flex-start":"center", color:isActive?ORANGE:t.text2, fontSize:13, textAlign:"left", whiteSpace:"nowrap", cursor:"pointer", transition:"all 0.15s", fontWeight:isActive?700:400 }}
                    onMouseEnter={e => { if(!isActive) e.currentTarget.style.background = "rgba(232,137,12,0.08)"; }}
                    onMouseLeave={e => { if(!isActive) e.currentTarget.style.background = "none"; }}
                  >
                    <span style={{ fontSize:14, flexShrink:0 }}>{item.emoji}</span>
                    {sbOpen && (
                      <>
                        <span style={{ flex:1 }}>{item.label}</span>
                        {count !== null && (
                          <span style={{ marginLeft:"auto", background:count>0?ORANGE:t.bg3, color:count>0?"#fff":t.text2, borderRadius:20, padding:"2px 8px", fontSize:10, fontWeight:700, minWidth:20, textAlign:"center" }}>{count}</span>
                        )}
                        {item.id === "wa" && waUnread > 0 && (
                          <span style={{ marginLeft:"auto", background:"#ef4444", color:"#fff", borderRadius:20, padding:"2px 8px", fontSize:10, fontWeight:700, minWidth:20, textAlign:"center" }}>{waUnread}</span>
                        )}
                      </>
                    )}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* MAIN CONTENT */}
        <div style={{ flex:1, overflowY:"auto", background:t.bg }}>
          {showSettings && <SettingsPage t={t} dark={dark} setDark={setDark}/>}

          {!showSettings && selClient && (
            <ClientPage
              client={selClient}
              onBack={() => { setSelClient(null); setPage("all"); }}
              onUpdate={updated => { setClients(prev => prev.map(c => c.id===updated.id ? updated : c)); setSelClient(updated); }}
              t={t} user={me} showToast={showToast}
            />
          )}

          {!showSettings && !selClient && page==="search"    && <SearchPage clients={clients} onSelect={setSelClient} t={t}/>}
          {!showSettings && !selClient && page==="wa"        && <WAPage t={t} clients={clients}/>}
          {!showSettings && !selClient && page==="temp" && <TemplatesPage t={t} clients={clients}/>}
          {!showSettings && !selClient && page==="newclient" && <NewClientPage t={t} clients={clients} setClients={setClients} setPage={setPage} showToast={showToast} fetchClients={fetchClients}/>}

          {!showSettings && !selClient && page!=="search" && page!=="wa" && page!=="temp" && page!=="newclient" && (() => {
            const nav = NAV.find(n => n.id === page);
            if (!nav) return null;
            const list = nav.filter ? clients.filter(nav.filter) : clients;
            return (
              <div style={{ padding:26 }}>
                <div style={{ fontSize:22, fontWeight:800, color:t.text, marginBottom:22, display:"flex", alignItems:"center", gap:10 }}>
                  {nav.emoji} {nav.label}
                  <span style={{ fontSize:12, background:"rgba(232,137,12,0.12)", color:ORANGE, padding:"3px 10px", borderRadius:20, fontWeight:700 }}>{list.length}</span>
                </div>
                <ClientTable clients={list} onSelect={setSelClient} t={t} title={nav.label}/>
              </div>
            );
          })()}
        </div>
      </div>

      <Toast msg={toast.msg} show={toast.show}/>
    </div>
  );
}
